export const frLocalization = {
  fr: {
    grid: {
      EmptyRecord: "Aucun enregistrement à afficher",
      True: "vrai",
      False: "faux",
      InvalidFilterMessage: "Données de filtre non valides",
      GroupDropArea:
        "Faites glisser un en-tête de colonne ici pour regrouper sa colonne",
      UnGroup: "Cliquez ici pour dissocier",
      GroupDisable: "Le regroupement est désactivé pour cette colonne",
      FilterbarTitle: 'Cellule de la barre de filtre "s',
      EmptyDataSourceError:
        "DataSource ne doit pas être vide lors du chargement initial, car les colonnes sont générées à partir de dataSource dans la grille de colonnes AutoGenerate",
      Add: "Ajouter",
      Edit: "Éditer",
      Cancel: "Annuler",
      Update: "Mise à jour",
      Delete: "Supprimer",
      Print: "Imprimer",
      Pdfexport: "Exportation PDF",
      Excelexport: "Exportation Excel",
      Wordexport: "Exportation Word",
      Csvexport: "Exportation CSV",
      Search: "Rechercher",
      Columnchooser: "Colonnes",
      Save: "Enregistrer",
      Item: "élément",
      Items: "éléments",
      EditOperationAlert:
        "Aucun enregistrement sélectionné pour l'opération de modification",
      DeleteOperationAlert:
        "Aucun enregistrement sélectionné pour l'opération de suppression",
      SaveButton: "Enregistrer",
      OKButton: "OK",
      CancelButton: "Annuler",
      EditFormTitle: "Détails de",
      AddFormTitle: "Ajouter un nouvel enregistrement",
      BatchSaveConfirm: "Voulez-vous vraiment enregistrer les modifications ?",
      BatchSaveLostChanges:
        "Les modifications non enregistrées seront perdues. Êtes-vous sûr de vouloir continuer ?",
      ConfirmDelete: "Voulez-vous vraiment supprimer cet enregistrement ?",
      CancelEdit: "Voulez-vous vraiment annuler les modifications ?",
      ChooseColumns: "Choisissez la colonne",
      SearchColumns: "colonnes de recherche",
      Matchs: "Aucun résultat",
      FilterButton: "Filtrer",
      ClearButton: "Effacer",
      StartsWith: "Commence par",
      EndsWith: "Se termine par",
      Contains: "Contient",
      Equal: "Égal",
      NotEqual: "Différent",
      LessThan: "Inférieur à",
      LessThanOrEqual: "Inférieur ou égal à",
      GreaterThan: "Supérieur à",
      GreaterThanOrEqual: "Supérieur ou égal à",
      ChooseDate: "Choisissez une date",
      EnterValue: "Entrez la valeur",
      Copy: "Copier",
      Group: "Regrouper par cette colonne",
      Ungroup: "Dissocier par cette colonne",
      autoFitAll: "Ajuster automatiquement toutes les colonnes",
      autoFit: "Ajuster automatiquement cette colonne",
      Export: "Exporter",
      FirstPage: "Première page",
      LastPage: "Dernière page",
      PreviousPage: "Page précédente",
      NextPage: "Page suivante",
      SortAscending: "Trier par ordre croissant",
      SortDescending: "Trier par ordre décroissant",
      EditRecord: "Modifier l'enregistrement",
      DeleteRecord: "Supprimer l'enregistrement",
      FilterMenu: "Filtrer",
      SelectAll: "Tout sélectionner",
      Blanks: "Vides",
      FilterTrue: "Vrai",
      FilterFalse: "Faux",
      NoResult: "Aucun résultat",
      ClearFilter: "Effacer le filtre",
      NumberFilter: "Filtres numériques",
      TextFilter: "Filtres de texte",
      DateFilter: "Filtres de date",
      DateTimeFilter: "Filtres DateTime",
      MatchCase: "Étui de correspondance",
      Between: "Entre",
      CustomFilter: "Filtre personnalisé",
      CustomFilterPlaceHolder: "Entrez la valeur",
      CustomFilterDatePlaceHolder: "Choisissez une date",
      AND: "ET",
      OR: "OU",
      ShowRowsWhere: "Afficher les lignes où :",
      NotStartsWith: "Ne commence pas par",
      Like: "Comme",
      NotEndsWith: "Ne se termine pas par",
      NotContains: "Ne contient pas",
      IsNull: "Null",
      NotNull: "Non Null",
      IsEmpty: "Vide",
      IsNotEmpty: "Non vide",
      AddCurrentSelection: "Ajouter la sélection actuelle au filtre",
      UnGroupButton: "Cliquez ici pour dissocier",
      AutoFitAll: "Ajuster automatiquement toutes les colonnes",
      AutoFit: "Ajuster automatiquement cette colonne",
      Clear: "Dégager",
      FilterMenuDialogARIA: "Boîte de dialogue du menu de filtre",
      ExcelFilterDialogARIA: "Boîte de dialogue du filtre Excel",
      DialogEditARIA: "Boîte de dialogue de modification",
      ColumnChooserDialogARIA: "Sélecteur de colonne",
      ColumnMenuDialogARIA: "Boîte de dialogue du menu des colonnes",
      CustomFilterDialogARIA: "Boîte de dialogue du filtre personnalisé",
      SortAtoZ: "Trier de A à Z",
      SortZtoA: "Trier de Z à A",
      SortByOldest: "Trier par le plus ancien",
      SortByNewest: "Trier par le plus récent",
      SortSmallestToLargest: "Trier du plus petit au plus grand",
      SortLargestToSmallest: "Trier du plus grand au plus petit",
      Sort: "Trier",
      FilterDescription: "Appuyez sur Alt Bas pour ouvrir le menu du filtre",
      SortDescription: "Appuyez sur Entrée pour trier",
      ColumnMenuDescription:
        "Appuyez sur Alt Bas pour ouvrir le menu des colonnes",
      GroupDescription: "Appuyez sur Ctrl espace pour grouper",
      ColumnHeader: " en-tête de colonne",
      TemplateCell: " est une cellule modèle",
      CommandColumnAria: "est l'en-tête de colonne de commande",
      DialogEdit: "Modifier la boîte de dialogue",
      ClipBoard: "Presse-papiers",
      GroupButton: "Bouton de regroupement",
      UnGroupAria: "Bouton de dissociation",
      GroupSeperator: "Séparateur pour les colonnes groupées",
      UnGroupIcon: "Dissocier la colonne groupée",
      GroupedSortIcon: "Trier la colonne groupée",
      GroupedDrag: "Faites glisser la colonne groupée",
      GroupCaption: " est une cellule de légende de groupe",
      CheckBoxLabel: "Case à cocher",
      Expanded: "Étendue",
      Collapsed: "S'est effondré",
      SelectAllCheckbox: "Case à cocher Tout sélectionner",
      SelectRow: "Sélectionner la ligne",
      AscendingText: "Ascendant",
      DescendingText: "Descendant",
      NoneText: "Aucun",
    },
    pager: {
      currentPageInfo: "{0} de {1} pages",
      totalItemsInfo: "({0} éléments)",
      firstPageTooltip: "Aller à la première page",
      lastPageTooltip: "Aller à la dernière page",
      nextPageTooltip: "Aller à la page suivante",
      previousPageTooltip: "Aller à la page précédente",
      nextPagerTooltip: "Aller aux éléments suivants du téléavertisseur",
      previousPagerTooltip:
        "Accéder aux éléments de téléavertisseur précédents",
      pagerDropDown: "Articles par page",
      pagerAllDropDown: "Articles",
      All: "Tout",
      totalItemInfo: "({0} élément)",
      Container: "Conteneur de téléavertisseur",
      Information: "Informations sur le téléavertisseur",
      ExternalMsg: "Message externe du téléavertisseur",
      Page: "Page",
      Of: " de ",
      Pages: " pages",
    },
    kanban: {
      items: "articles",
      min: "Min",
      max: "Max",
      cardsSelected: "Cartes sélectionnées",
      addTitle: "Ajouter une nouvelle carte",
      editTitle: "Modifier les détails de la carte",
      deleteTitle: "Supprimer la carte",
      deleteContent: "Êtes-vous sûr de vouloir supprimer cette carte ?",
      save: "sauver",
      delete: "Supprimer",
      cancel: "Annuler",
      yes: "Oui",
      no: "Non",
      close: "Fermer",
      noCard: "Aucune carte à afficher",
      unassigned: "Non assigné",
      cards: "Cartes",
    },
    dropdowns: {
      noRecordsTemplate: "Aucun enregistrement trouvé",
      actionFailureTemplate: "La demande a échoué",
      overflowCountTemplate: "+${count} de plus..",
      selectAllText: "Tout sélectionner",
      unSelectAllText: "Tout déselectionner",
      totalCountTemplate: "${count} sélectionnés",
    },
    "drop-down-list": {
      noRecordsTemplate: "Aucun enregistrement trouvé",
      actionFailureTemplate: "La demande a échoué",
    },
    "combo-box": {
      noRecordsTemplate: "Aucun enregistrement trouvé",
      actionFailureTemplate: "La demande a échoué",
    },
    "auto-complete": {
      noRecordsTemplate: "Aucun enregistrement trouvé",
      actionFailureTemplate: "La demande a échoué",
    },
    "multi-select": {
      noRecordsTemplate: "Aucun enregistrement trouvé",
      actionFailureTemplate: "La demande a échoué",
      overflowCountTemplate: "+${count} de plus..",
      selectAllText: "Tout sélectionner",
      unSelectAllText: "Tout déselectionner",
      totalCountTemplate: "${count} sélectionnés",
    },
    listbox: {
      noRecordsTemplate: "Aucun enregistrement trouvé",
      actionFailureTemplate: "La demande a échoué",
      selectAllText: "Tout sélectionner",
      unSelectAllText: "Tout déselectionner",
      moveUp: "Déplacer vers le haut",
      moveDown: "Déplacer vers le bas",
      moveTo: "Déplacer à",
      moveFrom: "Déplacer de",
      moveAllTo: "Déplacer tout vers",
      moveAllFrom: "Tout déplacer de",
    },
    spreadsheet: {
      InsertingEmptyValue: "La valeur de référence n'est pas valide.",
      FindValue: "Trouver la valeur",
      ReplaceValue: "Remplacer la valeur",
      FindReplaceTooltip: "Rechercher et remplacer",
      ByRow: "Par lignes",
      ByColumn: "Par colonnes",
      MatchExactCellElements: "Correspondance exacte du contenu de la cellule",
      EnterCellAddress: "Entrez l'adresse de la cellule",
      FindAndReplace: "Trouver et remplacer",
      ReplaceAllEnd: " correspondances remplacées par ",
      FindNextBtn: "Rechercher suivant",
      FindPreviousBtn: "Rechercher précédent",
      ReplaceBtn: "Remplacer",
      ReplaceAllBtn: "Tout remplacer",
      GotoHeader: "Aller à",
      Sheet: "Feuille",
      SearchWithin: "Rechercher dans",
      SearchBy: "Rechercher par",
      Reference: "Référence",
      Workbook: "Cahier",
      NoElements: "Nous n'avons pas trouvé ce que vous cherchiez.",
      FindWhat: "Trouver quoi",
      ReplaceWith: "Remplacer par",
      FileName: "Nom de fichier",
      ExtendValidation:
        "La sélection contient certaines cellules sans validation des données. Voulez-vous étendre la validation à ces cellules ?",
      Yes: "Oui",
      No: "Non",
      PROPER:
        "Convertit un texte en cas approprié ; première lettre en majuscule et les autres lettres en minuscule.",
      Cut: "Couper",
      Copy: "Copier",
      Paste: "Coller",
      PasteSpecial: "Collage spécial",
      All: "Tous",
      Values: "Valeurs",
      Formats: "Formats",
      Font: "Police de caractère",
      FontSize: "Taille de police",
      Bold: "Audacieux",
      Italic: "Italique",
      Underline: "Souligner",
      Strikethrough: "Barré",
      TextColor: "Couleur du texte",
      FillColor: "Couleur de remplissage",
      HorizontalAlignment: "Alignement horizontal",
      AlignLeft: "Aligner à gauche",
      AlignCenter: "Aligner au centre",
      AlignRight: "Aligner à droite",
      VerticalAlignment: "Alignement vertical",
      AlignTop: "Aligner en haut",
      AlignMiddle: "Aligner au milieu",
      AlignBottom: "Aligner en bas",
      MergeCells: "Fusionner les cellules",
      MergeAll: "Tout fusionner",
      MergeHorizontally: "Fusionner horizontalement",
      MergeVertically: "Fusionner verticalement",
      Unmerge: "Annuler la fusion",
      UnmergeCells: "Annuler la fusion des cellules",
      SelectMergeType: "Sélectionner le type de fusion",
      MergeCellsAlert:
        "La fusion de cellules ne conservera que la valeur la plus à gauche (Uppermost). Fusionner quand même ?",
      PasteMergeAlert: "Impossible de faire cela sur une cellule fusionnée.",
      Borders: "Bordures",
      TopBorders: "Bordures supérieures",
      LeftBorders: "Bordures de gauche",
      RightBorders: "Bordures à droite",
      BottomBorders: "Bordures inférieures",
      AllBorders: "Toutes les bordures",
      HorizontalBorders: "Bordures horizontales",
      VerticalBorders: "Bordures verticales",
      OutsideBorders: "Bordures extérieures",
      InsideBorders: "Bordures intérieures",
      NoBorders: "Pas de bordures",
      BorderColor: "Couleur des bordures",
      BorderStyle: "Style des bordures",
      InsertFunction: "Insérer une fonction",
      Insert: "Insérer",
      Delete: "Supprimer",
      DuplicateSheet: "Dupliquer",
      MoveRight: "Déplacer à droite",
      MoveLeft: "Déplacer à gauche",
      Rename: "Renommer",
      Hide: "Cacher",
      NameBox: "Boîte de nom",
      ShowHeaders: "Afficher les en-têtes",
      HideHeaders: "Masquer les en-têtes",
      ShowGridLines: "Afficher les quadrillages",
      HideGridLines: "Masquer les quadrillages",
      FreezePanes: "Figer les volets",
      FreezeRows: "Figer les lignes",
      FreezeColumns: "Figer les colonnes",
      UnfreezePanes: "Dégeler les volets",
      UnfreezeRows: "Dégeler les lignes",
      UnfreezeColumns: "Dégeler les colonnes",
      AddSheet: "Ajouter une feuille",
      ListAllSheets: "Répertorier toutes les feuilles",
      CollapseToolbar: "Réduire la barre d'outils",
      ExpandToolbar: "Développer la barre d'outils",
      CollapseFormulaBar: "Réduire la barre de formule",
      ExpandFormulaBar: "Agrandir la barre de formule",
      File: "Fichier",
      Home: "Domicile",
      Formulas: "Formules",
      View: "Vue",
      New: "Nouveau",
      Open: "Ouvrir",
      SaveAs: "Enregistrer sous",
      ExcelXlsx: "Microsoft Excel",
      ExcelXls: "Microsoft Excel 97-2003",
      CSV: "Valeurs séparées par des virgules",
      FormulaBar: "Barre de formule",
      Sort: "Trier",
      SortAscending: "Ascendant",
      SortDescending: "Décroissant",
      CustomSort: "Tri personnalisé",
      AddColumn: "Ajouter une colonne",
      ContainsHeader: "Les données contiennent un en-tête",
      CaseSensitive: "Sensible aux majuscules et minuscules",
      SortBy: "Trier par",
      ThenBy: "Puis par",
      SelectAColumn: "Sélectionner une colonne",
      SortEmptyFieldError:
        "Tous les critères de tri doivent avoir une colonne spécifiée. Vérifiez les critères de tri sélectionnés et réessayez.",
      SortDuplicateFieldError:
        " est trié par valeurs plus d'une fois. Supprimez les critères de tri en double et réessayez.",
      SortOutOfRangeError:
        "Sélectionnez une cellule ou une plage à l'intérieur de la plage utilisée et réessayez.",
      MultiRangeSortError:
        "Cela ne peut pas être fait sur une sélection de plages multiples. Sélectionnez une seule plage et réessayez.",
      HideRow: "Masquer la ligne",
      HideRows: "Masquer les lignes",
      UnhideRows: "Afficher les lignes",
      HideColumn: "Masquer la colonne",
      HideColumns: "Masquer les colonnes",
      UnhideColumns: "Afficher les colonnes",
      InsertRow: "Insérer une ligne",
      InsertRows: "Insérer des lignes",
      Above: "Au-dessus",
      Below: "En-dessous",
      InsertColumn: "Insérer une colonne",
      InsertColumns: "Insérer des colonnes",
      Before: "Avant",
      After: "Après",
      DeleteRow: "Supprimer la ligne",
      DeleteRows: "Supprimer les lignes",
      DeleteColumn: "Supprimer la colonne",
      DeleteColumns: "Supprimer les colonnes",
      Ok: "OK",
      Close: "Fermer",
      MoreOptions: "Plus d'options",
      Cancel: "Annuler",
      Apply: "Appliquer",
      MoreColors: "Plus de couleurs",
      StandardColors: "Couleurs standard",
      General: "Général",
      Number: "Nombre",
      Currency: "Devise",
      Accounting: "Comptabilité",
      ShortDate: "Date courte",
      LongDate: "Date longue",
      Time: "Temps",
      Percentage: "Pourcentage",
      Fraction: "Fraction",
      Scientific: "Scientifique",
      Text: "Texte",
      NumberFormat: "Format de nombre",
      MobileFormulaBarPlaceHolder: "Entrez une valeur ou une formule",
      PasteAlert:
        "Vous ne pouvez pas coller ceci ici, car la zone de copie et la zone de collage ne sont pas de la même taille. Veuillez essayer de coller dans une autre plage.",
      DestroyAlert:
        "Voulez-vous vraiment détruire le classeur actuel sans enregistrer et créer un nouveau classeur ?",
      SheetRenameInvalidAlert:
        "Le nom de la feuille contient un caractère non valide.",
      SheetRenameEmptyAlert: "Le nom de la feuille ne peut pas être vide.",
      SheetRenameAlreadyExistsAlert:
        "Le nom de la feuille existe déjà. Veuillez entrer un autre nom.",
      DeleteSheetAlert: "Êtes-vous sûr de vouloir supprimer cette feuille ?",
      DeleteSingleLastSheetAlert:
        "Un classeur doit contenir au moins une feuille de calcul visible.",
      PickACategory: "Choisissez une catégorie",
      Description: "Description",
      UnsupportedFile: "Fichier non pris en charge",
      DataLimitExceeded:
        "Les données du fichier sont trop volumineuses et le traitement prendra plus de temps, voulez-vous continuer ?",
      FileSizeLimitExceeded:
        "La taille du fichier est trop grande et le traitement prendra plus de temps, voulez-vous continuer ?",
      InvalidUrl: "URL invalide",
      SUM: "Ajoute une série de nombres et/ou de cellules.",
      SUMIF: "Ajoute les cellules en fonction de la condition spécifiée.",
      SUMIFS: "Ajoute les cellules en fonction des conditions spécifiées.",
      ABS: "Renvoie la valeur d'un nombre sans son signe.",
      RAND: "Renvoie un nombre aléatoire entre 0 et 1.",
      RANDBETWEEN:
        "Renvoie un entier aléatoire basé sur les valeurs spécifiées.",
      FLOOR:
        "Arrondit un nombre au multiple inférieur le plus proche d'un facteur donné.",
      CEILING:
        "Arrondit un nombre au multiple le plus proche d'un facteur donné.",
      PRODUCT: "Multiplie une série de nombres et/ou de cellules.",
      AVERAGE:
        "Calcule la moyenne de la série de nombres et/ou de cellules excluant le texte.",
      AVERAGEIF:
        "Calcule la moyenne des cellules en fonction du critère spécifié.",
      AVERAGEIFS:
        "Calcule la moyenne des cellules en fonction des conditions spécifiées.",
      AVERAGEA:
        "Calcule la moyenne des cellules évaluant VRAI comme 1, texte et FAUX comme 0.",
      COUNT:
        "Compte les cellules qui contiennent des valeurs numériques dans une plage.",
      COUNTIF: "Compte les cellules en fonction de la condition spécifiée.",
      COUNTIFS: "Compte les cellules en fonction des conditions spécifiées.",
      COUNTA: "Compte les cellules qui contiennent des valeurs dans une plage.",
      MIN: "Renvoie le plus petit nombre d'arguments donnés.",
      MAX: "Renvoie le plus grand nombre d'arguments donnés.",
      DATE: "Renvoie la date en fonction de l'année, du mois et du jour donnés.",
      DAY: "Renvoie le jour à partir de la date donnée.",
      DAYS: "Renvoie le nombre de jours entre deux dates.",
      IF: "Renvoie une valeur basée sur l'expression donnée.",
      IFS: "Renvoie une valeur basée sur les multiples expressions données.",
      CalculateAND:
        "Renvoie TRUE si tous les arguments sont TRUE, sinon renvoie FALSE.",
      CalculateOR:
        "Renvoie TRUE si l'un des arguments est TRUE, sinon renvoie FALSE.",
      IFERROR:
        "Renvoie une valeur si aucune erreur n'est trouvée sinon retourne la valeur spécifiée.",
      CHOOSE:
        "Renvoie une valeur à partir d'une liste de valeurs, basée sur le numéro d'index.",
      INDEX:
        "Renvoie une valeur de la cellule dans une plage donnée en fonction du numéro de ligne et de colonne.",
      FIND: "Renvoie la position d'une chaîne dans une autre chaîne, qui est sensible à la casse.",
      CONCATENATE: "Combine deux ou plusieurs chaînes ensemble.",
      CONCAT: "Concatène une liste ou une plage de chaînes de texte.",
      SUBTOTAL:
        "Renvoie le sous-total pour une plage à l'aide du numéro de fonction donné.",
      RADIANS: "Convertit des degrés en radians.",
      MATCH:
        "Renvoie la position relative d'une valeur spécifiée dans une plage donnée.",
      SLOPE:
        "Renvoie la pente de la ligne à partir de la régression linéaire des points de données.",
      INTERCEPT:
        "Calcule le point de la ligne d'ordonnée à l'origine via une régression linéaire.",
      UNIQUE: "Renvoie des valeurs uniques d'une plage ou d'un tableau.",
      TEXT: "Convertit une valeur en texte dans le format numérique spécifié.",
      DefineNameExists: "Ce nom existe déjà, essayez un autre nom.",
      CircularReference:
        "Lorsqu'une formule fait référence à une ou plusieurs références circulaires, cela peut entraîner un calcul incorrect.",
      SORT: "Trie une plage d'un tableau",
      T: "Vérifie si une valeur est du texte ou non et renvoie le texte.",
      EXACT:
        "Vérifie si deux chaînes de texte sont exactement identiques et renvoie TRUE ou FALSE.",
      LEN: "Renvoie le nombre de caractères dans une chaîne donnée.",
      MOD: "Renvoie le reste après qu'un nombre a été divisé par un diviseur.",
      ODD: "Arrondit un nombre positif à l'entier impair le plus proche et un nombre négatif vers le bas.",
      PI: "Renvoie la valeur de pi.",
      COUNTBLANK:
        "Renvoie le nombre de cellules vides dans une plage spécifiée.",
      EVEN: "Arrondit un nombre positif à l'entier pair le plus proche et un nombre négatif vers le bas.",
      DECIMAL:
        "Convertit une représentation textuelle d'un nombre dans une base donnée en un nombre décimal.",
      ADDRESS:
        "Renvoie une référence de cellule sous forme de texte, en fonction des numéros de ligne et de colonne spécifiés.",
      CHAR: "Renvoie le caractère correspondant au nombre spécifié.",
      CODE: "Renvoie le code numérique du premier caractère d'une chaîne donnée.",
      DOLLAR: "Convertit un nombre en texte au format monétaire.",
      SMALL: "Renvoie la k-ième plus petite valeur dans un tableau donné.",
      LARGE: "Renvoie la k-ième plus grande valeur dans un tableau donné.",
      TIME: "Convertit les heures, les minutes et les secondes en texte au format horaire.",
      DEGREES: "Convertit les radians en degrés.",
      FACT: "Renvoie la factorielle d'un nombre.",
      MEDIAN: "Renvoie la médiane de l'ensemble de nombres donné.",
      EDATE:
        "Renvoie une date avec un nombre donné de mois avant ou après la date spécifiée.",
      DATEVALUE: "Convertit une chaîne de date en valeur de date.",
      NOW: "Renvoie la date et l'heure actuelles.",
      HOUR: "Renvoie le nombre d'heures dans une chaîne de temps spécifiée.",
      MINUTE:
        "Renvoie le nombre de minutes dans une chaîne de temps spécifiée.",
      SECOND:
        "Renvoie le nombre de secondes dans une chaîne de temps spécifiée.",
      MONTH: "Renvoie le nombre de mois dans une chaîne de date spécifiée.",
      OR: "OU ALORS",
      AND: "ET",
      CustomFilterDatePlaceHolder: "Choisissez une date",
      CustomFilterPlaceHolder: "Entrez la valeur",
      CustomFilter: "Filtre personnalisé",
      Between: "Compris entre",
      MatchCase: "Cas de correspondance",
      DateTimeFilter: "Filtres DateHeure",
      Undo: "annuler",
      Redo: "Refaire",
      ClearAllFilter: "Dégager",
      ReapplyFilter: "Réappliquer",
      DateFilter: "Filtres de dates",
      TextFilter: "Filtres de texte",
      NumberFilter: "Filtres numériques",
      ClearFilter: "Effacer le filtre",
      NoResult: "Aucun résultat",
      FilterFalse: "Faux",
      FilterTrue: "Vrai",
      Blanks: "Blancs",
      SelectAll: "Tout sélectionner",
      GreaterThanOrEqual: "Meilleur que ou égal",
      GreaterThan: "Plus grand que",
      LessThanOrEqual: "Inférieur ou égal",
      LessThan: "Moins que",
      NotEqual: "Inégal",
      Equal: "Égal",
      Contains: "Contient",
      NotContains: "Ne contient pas",
      EndsWith: "Se termine par",
      NotEndsWith: "Ne se termine pas par",
      StartsWith: "Commence avec",
      NotStartsWith: "Ne commence pas par",
      IsEmpty: "Vide",
      IsNotEmpty: "Pas vide",
      ClearButton: "Dégager",
      FilterButton: "Filtre",
      CancelButton: "Annuler",
      OKButton: "D'ACCORD",
      Search: "Rechercher",
      DataValidation: "La validation des données",
      CellRange: "Plage de cellules",
      Allow: "Permettre",
      Data: "Données",
      Minimum: "Le minimum",
      Maximum: "Maximum",
      IgnoreBlank: "Ignorer le blanc",
      WholeNumber: "Nombre entier",
      Decimal: "Décimal",
      Date: "Date",
      TextLength: "Longueur du texte",
      List: "Liste",
      NotBetween: "Pas entre",
      EqualTo: "Égal à",
      NotEqualTo: "Pas égal à",
      GreaterThanOrEqualTo: "Plus grand ou égal à",
      LessThanOrEqualTo: "Inférieur ou égal à",
      InCellDropDown: "Liste déroulante dans la cellule",
      Sources: "Sources",
      Value: "Évaluer",
      Formula: "Formule",
      Retry: "Retenter",
      DialogError:
        "La source de la liste doit être une référence à une seule ligne ou colonne.",
      MinMaxError: "Le maximum doit être supérieur ou égal au minimum.",
      InvalidNumberError: "Veuillez entrer un numéro valide.",
      InvalidFormula: "Veuillez entrer une formule valide.",
      Spreadsheet: "Tableur",
      MoreValidation: "Cette sélection contient plus d'une validation.",
      FileNameError:
        'Un nom de fichier ne peut pas contenir de caractères tels que \\ / : * ? " < > [ ] |',
      ValidationError:
        "Cette valeur ne correspond pas aux restrictions de validation des données définies pour la cellule.",
      ListLengthError:
        "Les valeurs de la liste ne permettent que jusqu'à 256 caractères",
      ProtectSheet: "Feuille de protection",
      UnprotectSheet: "Déprotéger la feuille",
      SelectCells: "Sélectionnez les cellules verrouillées",
      SelectUnlockedCells: "Sélectionnez les cellules déverrouillées",
      Save: "Sauver",
      EmptyFileName: "Le nom du fichier ne peut pas être vide.",
      LargeName: "Le nom est trop long.",
      FormatCells: "Formater les cellules",
      FormatRows: "Mettre en forme les lignes",
      FormatColumns: "Formater les colonnes",
      InsertLinks: "Insérer des liens",
      ProtectContent: "Protéger le contenu des cellules verrouillées",
      ProtectAllowUser:
        " Autoriser tous les utilisateurs de cette feuille de calcul à :",
      EditAlert:
        "La cellule que vous essayez de modifier est protégée. Pour rendre la monnaie, déprotégez la feuille.",
      ReadonlyAlert:
        "Vous essayez de modifier une cellule qui est en mode lecture seule. Pour apporter des modifications, veuillez désactiver le statut de lecture seule.",
      ClearValidation: "Effacer la validation",
      ISNUMBER:
        "Renvoie true lorsque la valeur est analysée en tant que valeur numérique.",
      ROUND: "Arrondit un nombre à un nombre de chiffres spécifié.",
      GEOMEAN:
        "Renvoie la moyenne géométrique d'un tableau ou d'une plage de données positives.",
      POWER: "Renvoie le résultat d'un nombre élevé à la puissance",
      LOG: "Renvoie le logarithme d'un nombre à la base que vous spécifiez.",
      TRUNC:
        "Renvoie la valeur tronquée d'un nombre à un nombre spécifié de décimales.",
      EXP: "Renvoie e élevé à la puissance du nombre donné.",
      LOOKUP:
        "Recherche une valeur dans une plage à une seule ligne ou à une seule colonne, puis renvoie une valeur au même emplacement dans une plage à une seule ligne ou à une seule colonne.",
      HLOOKUP:
        "Recherche la valeur dans la ligne supérieure du tableau de valeurs, puis renvoie la valeur dans la même colonne que la ligne du tableau que vous avez spécifiée.",
      VLOOKUP:
        "Recherche la valeur spécifiée dans la première colonne de la plage de recherche et renvoie la valeur correspondante dans la deuxième colonne de la même ligne.",
      NOT: "Renvoie l'inverse de l'expression logique spécifiée.",
      EOMONTH:
        "Renvoie le dernier jour du mois correspondant au nombre de mois spécifié avant ou après la date de début initialement spécifiée.",
      SQRT: "Renvoie la racine carrée d'un nombre positif.",
      ROUNDDOWN: "Arrondissez le nombre à zéro.",
      RSQ: "Renvoie le coefficient de corrélation quadratique du moment du produit Pearson en fonction des points de données known_y et known_x.",
      HighlightCellsRules: "Mettre en surbrillance les règles des cellules",
      CFEqualTo: "Égal à",
      TextThatContains: "Texte qui contient",
      ADateOccuring: "Une date survenant",
      DuplicateValues: "Valeurs en double",
      TopBottomRules: "Règles du haut/du bas",
      Top10Items: "Top 10 des articles",
      Top10: "Top 10",
      Bottom10Items: "Les 10 derniers articles",
      Bottom10: "Les 10 derniers",
      AboveAverage: "Au dessus de la moyenne",
      BelowAverage: "Sous la moyenne",
      FormatCellsGreaterThan: "Mettre en forme les cellules supérieures à :",
      FormatCellsLessThan: "Mettre en forme les cellules inférieures à :",
      FormatCellsBetween: "Mettre en forme les cellules qui sont ENTRE :",
      FormatCellsEqualTo: "Mettre en forme les cellules qui sont ÉGALES À :",
      FormatCellsThatContainTheText:
        "Mettre en forme les cellules contenant le texte :",
      FormatCellsThatContainADateOccurring:
        "Mettre en forme les cellules contenant une date :",
      FormatCellsDuplicate: "Mettre en forme les cellules contenant :",
      FormatCellsTop: "Formatez les cellules qui se classent dans le TOP :",
      FormatCellsBottom:
        "Mettre en forme les cellules qui se classent en BAS :",
      FormatCellsAbove:
        "Mettre en forme les cellules qui sont SUPÉRIEURES À LA MOYENNE :",
      FormatCellsBelow:
        "Mettre en forme les cellules qui sont INFÉRIEURES À LA MOYENNE :",
      With: "avec",
      DataBars: "Barres de données",
      ColorScales: "Échelles de couleurs",
      IconSets: "Ensembles d'icônes",
      ClearRules: "Règles claires",
      SelectedCells: "Effacer les règles des cellules sélectionnées",
      EntireSheet: "Effacer les règles de la feuille entière",
      LightRedFillWithDarkRedText:
        "Remplissage rouge clair avec texte rouge foncé",
      YellowFillWithDarkYellowText: "Remplissage jaune avec texte jaune foncé",
      GreenFillWithDarkGreenText: "Remplissage vert avec texte vert foncé",
      RedFill: "Remplissage rouge",
      RedText: "Texte rouge",
      Duplicate: "Dupliquer",
      Unique: "Unique",
      And: "et",
      WebPage: "Page Web",
      ThisDocument: "Ce document",
      DisplayText: "Afficher le texte",
      Url: "URL",
      CellReference: "Référence de cellule",
      DefinedNames: "Noms définis",
      EnterTheTextToDisplay: "Entrez le texte à afficher",
      EnterTheUrl: "Saisissez l'URL",
      INT: "Renvoie un nombre à l'entier le plus proche.",
      SUMPRODUCT: "Renvoie la somme du produit de plages de tableaux données.",
      TODAY: "Renvoie la date actuelle comme valeur de date.",
      ROUNDUP: "Arrondit un nombre à partir de zéro.",
      Link: "Lien",
      Hyperlink: "Lien hypertexte",
      EditHyperlink: "Modifier le lien hypertexte",
      OpenHyperlink: "Ouvrir le lien hypertexte",
      RemoveHyperlink: "Supprimer le lien hypertexte",
      InvalidHyperlinkAlert:
        "L'adresse de ce site n'est pas valide. Vérifie l'adresse et essaye de nouveau.",
      InsertLink: "Insérer un lien",
      EditLink: "Modifier le lien",
      WrapText: "Envelopper le texte",
      Update: "Mettre à jour",
      SortAndFilter: "Trier et filtrer",
      Filter: "Filtre",
      FilterCellValue: "Filtrer par valeur de la cellule sélectionnée",
      FilterOutOfRangeError:
        "Sélectionnez une cellule ou une plage à l'intérieur de la plage utilisée et réessayez.",
      ClearFilterFrom: "Effacer le filtre de",
      LN: "Renvoie le logarithme naturel d'un nombre.",
      DefineNameInValid: "Le nom que vous avez saisi n'est pas valide.",
      EmptyError: "Vous devez entrer une valeur",
      ClearHighlight: "Effacer la surbrillance",
      HighlightInvalidData: "Mettre en surbrillance les données non valides",
      Clear: "Dégager",
      ClearContents: "Effacer le contenu",
      ClearAll: "Tout effacer",
      ClearFormats: "Effacer les formats",
      ClearHyperlinks: "Effacer les hyperliens",
      Image: "Image",
      ConditionalFormatting: "Mise en forme conditionnelle",
      BlueDataBar: "Barre de données bleue",
      GreenDataBar: "Barre de données verte",
      RedDataBar: "Barre de données rouge",
      OrangeDataBar: "Barre de données orange",
      LightBlueDataBar: "Barre de données bleu clair",
      PurpleDataBar: "Barre de données violette",
      GYRColorScale: "Échelle de couleur vert - jaune - rouge",
      RYGColorScale: "Échelle de couleurs rouge - jaune - vert",
      GWRColorScale: "Échelle de couleur vert - blanc - rouge",
      RWGColorScale: "Échelle de couleur rouge - blanc - vert",
      BWRColorScale: "Échelle de couleur bleu - blanc - rouge",
      RWBColorScale: "Échelle de couleurs rouge - blanc - bleu",
      WRColorScale: "Échelle de couleur blanc - rouge",
      RWColorScale: "Échelle de couleur rouge - blanc",
      GWColorScale: "Échelle de couleur vert - blanc",
      WGColorScale: "Échelle de couleur blanc - vert",
      GYColorScale: "Échelle de couleur vert - jaune",
      YGColorScale: "Échelle de couleur jaune - vert",
      ThreeArrowsColor: "3 flèches (colorées)",
      ThreeArrowsGray: "3 Flèches (Gris)",
      ThreeTriangles: "3 triangles",
      FourArrowsColor: "4 Flèches (Gris)",
      FourArrowsGray: "4 flèches (colorées)",
      FiveArrowsColor: "5 Flèches (Gris)",
      FiveArrowsGray: "5 flèches (colorées)",
      ThreeTrafficLights1: "3 feux de signalisation (sans bordure)",
      ThreeTrafficLights2: "3 feux de circulation (cerclés)",
      ThreeSigns: "3 signes",
      FourTrafficLights: "4 feux de circulation",
      RedToBlack: "Rouge à noir",
      ThreeSymbols1: "3 symboles (encerclés)",
      ThreeSymbols2: "3 symboles (sans cercle)",
      ThreeFlags: "3 drapeaux",
      ThreeStars: "3 étoiles",
      FourRatings: "4 notes",
      FiveQuarters: "5 trimestres",
      FiveRatings: "5 notes",
      FiveBoxes: "5 Boîtes",
      Chart: "Graphique",
      Column: "Colonne",
      Bar: "Bar",
      Area: "Zone",
      Pie: "Tarte",
      Doughnut: "Donut",
      PieAndDoughnut: "Tarte/Beignet",
      Line: "La ligne",
      Radar: "Radar",
      Scatter: "Dispersion",
      ChartDesign: "Conception de graphique",
      ClusteredColumn: "Colonne groupée",
      StackedColumn: "Colonne empilée",
      StackedColumn100: "Colonne empilée à 100 %",
      ClusteredBar: "Barre groupée",
      StackedBar: "Barre empilée",
      StackedBar100: "Barre empilée à 100 %",
      StackedArea: "Zone empilée",
      StackedArea100: "100 % de zone empilée",
      StackedLine: "Ligne empilée",
      StackedLine100: "Ligne empilée à 100 %",
      LineMarker: "Ligne avec marqueurs",
      StackedLineMarker: "Ligne empilée avec marqueurs",
      StackedLine100Marker: "Ligne empilée à 100 % avec marqueurs",
      AddChartElement: "Ajouter un élément de graphique",
      Axes: "Haches",
      AxisTitle: "Titre de l'axe",
      ChartTitle: "Titre du graphique",
      DataLabels: "Étiquettes de données",
      Gridlines: "Quadrillage",
      Legends: "Légendes",
      PrimaryHorizontal: "Horizontale primaire",
      PrimaryVertical: "Verticale primaire",
      None: "Aucun",
      AboveChart: "Graphique ci-dessus",
      Center: "Centre",
      InsideEnd: "Fin intérieure",
      InsideBase: "À l'intérieur de la base",
      OutsideEnd: "Extrémité extérieure",
      PrimaryMajorHorizontal: "Primaire Majeur Horizontal",
      PrimaryMajorVertical: "Primaire Majeur Vertical",
      PrimaryMinorHorizontal: "Primaire Mineure Horizontale",
      PrimaryMinorVertical: "Primaire Mineure Verticale",
      Right: "Droite",
      Left: "Gauche",
      Bottom: "Bas",
      Top: "Haut",
      SwitchRowColumn: "Changer de ligne/colonne",
      ChartTheme: "Thème du graphique",
      ChartType: "Type de graphique",
      Material: "Matériau",
      Fabric: "Tissu",
      Bootstrap: "Amorcer",
      HighContrastLight: "Lumière à contraste élevé",
      MaterialDark: "Matériau foncé",
      FabricDark: "Tissu Foncé",
      HighContrast: "Contraste élevé",
      BootstrapDark: "Bootstrap foncé",
      Bootstrap4: "Bootstrap4",
      Bootstrap5Dark: "Bootstrap5 Sombre",
      Bootstrap5: "Bootstrap5",
      Tailwind: "Vent arrière",
      TailwindDark: "Vent arrière sombre",
      Tailwind3: "Vent Arrière 3",
      Tailwind3Dark: "Vent Arrière 3 Sombre",
      VerticalAxisTitle: "Titre de l'axe vertical",
      HorizontalAxisTitle: "Titre de l'axe horizontal",
      EnterTitle: "Entrez le titre",
      UnprotectWorksheet: "Déprotéger la feuille",
      ReEnterPassword: "Entrez à nouveau le mot de passe pour continuer",
      SheetPassword: "Mot de passe pour déprotéger la feuille :",
      ProtectWorkbook: "Protéger le classeur",
      Password: "Mot de passe (facultatif) :",
      EnterThePassword: "Entrer le mot de passe",
      ConfirmPassword: "Confirmez le mot de passe",
      EnterTheConfirmPassword: "Entrez à nouveau votre mot de passe",
      PasswordAlert: "Le mot de passe de confirmation n'est pas identique",
      UnprotectWorkbook: "Déprotéger le classeur",
      UnprotectPasswordAlert:
        "Le mot de passe que vous avez fourni n'est pas correct.",
      IncorrectPassword:
        "Impossible d'ouvrir le fichier ou la feuille de calcul avec le mot de passe donné",
      PasswordAlertMsg: "S'il vous plaît entrer le mot de passe",
      ConfirmPasswordAlertMsg:
        "Veuillez entrer le mot de passe de confirmation",
      IsProtected: "est protégé",
      PDF: "Documents PDF",
      AutoFillMergeAlertMsg:
        "Pour ce faire, toutes les cellules fusionnées doivent avoir la même taille.",
      Fluent: "Courant",
      FluentDark: "Courant Sombre",
      Fluent2: "Courant 2",
      Fluent2Dark: "Courant 2 Foncé",
      Fluent2HighContrast: "Fluent 2 contraste élevé",
      Custom: "Personnalisé",
      WEEKDAY: "Renvoie le jour de la semaine correspondant à une date.",
      FillSeries: "Remplir la série",
      CopyCells: "Copier les cellules",
      FillFormattingOnly: "Remplir la mise en forme uniquement",
      FillWithoutFormatting: "Remplir sans formater",
      CustomFormat: "Formats de nombre personnalisés",
      CustomFormatPlaceholder: "Tapez ou sélectionnez un format personnalisé",
      CustomFormatTypeList: "Taper",
      CellReferenceTypoError:
        "Nous avons trouvé une faute de frappe dans votre référence de cellule. Voulez-vous corriger cette référence comme suit ?",
      AddCurrentSelection: "Ajouter la sélection actuelle au filtre",
      ExternalWorkbook:
        "Un fichier Excel importé contient une référence de classeur externe. Voulez-vous importer ce fichier ?",
      Directional: "Directionnel",
      Shapes: "Formes",
      Indicators: "Indicateurs",
      Ratings: "Notes",
      InvalidFormulaError:
        "Nous avons constaté que vous avez saisi une formule non valide.",
      InvalidArguments:
        "Nous avons constaté que vous avez saisi une formule avec des arguments non valides.",
      EmptyExpression:
        "Nous avons constaté que vous aviez tapé une formule avec une expression vide.",
      MismatchedParenthesis:
        "Nous avons constaté que vous avez tapé une formule avec une ou plusieurs parenthèses ouvrantes ou fermantes manquantes.",
      ImproperFormula:
        "Nous avons constaté que vous avez saisi une formule incorrecte.",
      WrongNumberOfArguments:
        "Nous avons constaté que vous avez saisi une formule avec un nombre incorrect d'arguments.",
      Requires3Arguments:
        "Nous avons constaté que vous avez tapé une formule qui nécessite 3 arguments.",
      MismatchedStringQuotes:
        "Nous avons constaté que vous aviez saisi une formule avec des guillemets incompatibles.",
      FormulaCircularRef:
        "Nous avons constaté que vous aviez tapé une formule avec une référence circulaire.",
    },
    filemanager: {
      NewFolder: "Nouveau dossier",
      Upload: "Téléverser",
      Delete: "Supprimer",
      Rename: "Renommer",
      Download: "Télécharger",
      Cut: "Couper",
      Copy: "Copier",
      Paste: "Coller",
      SortBy: "Trier par",
      Refresh: "Rafraîchir",
      "Item-Selection": "élément sélectionné",
      "Items-Selection": "éléments sélectionnés",
      View: "Vue",
      Details: "Détails",
      SelectAll: "Tout sélectionner",
      Open: "Ouvrir",
      "Tooltip-NewFolder": "Nouveau dossier",
      "Tooltip-Upload": "Téléverser",
      "Tooltip-Delete": "Supprimer",
      "Tooltip-Rename": "Renommer",
      "Tooltip-Download": "Télécharger",
      "Tooltip-Cut": "Couper",
      "Tooltip-Copy": "Copier",
      "Tooltip-Paste": "Coller",
      "Tooltip-SortBy": "Trier par",
      "Tooltip-Refresh": "Rafraîchir",
      "Tooltip-Selection": "Effacer la sélection",
      "Tooltip-View": "Vue",
      "Tooltip-Details": "Détails",
      "Tooltip-SelectAll": "Tout sélectionner",
      Name: "Nom",
      Size: "Taille",
      DateModified: "Date de modification",
      DateCreated: "Date créée",
      Path: "Chemin",
      Modified: "Modifié",
      Created: "Créé",
      Location: "Emplacement",
      Type: "Taper",
      Permission: "Permission",
      Ascending: "Ascendant",
      Descending: "Descendant",
      None: "Aucun",
      "View-LargeIcons": "Grandes icônes",
      "View-Details": "Détails",
      Search: "Recherche",
      "Button-Ok": "OK",
      "Button-Cancel": "Annuler",
      "Button-Yes": "Oui",
      "Button-No": "Non",
      "Button-Create": "Créer",
      "Button-Save": "Enregistrer",
      "Header-NewFolder": "Dossier",
      "Content-NewFolder": "Entrez le nom de votre dossier",
      "Header-Rename": "Renommer",
      "Content-Rename": "Entrez votre nouveau nom",
      "Header-Rename-Confirmation": "Renommer la confirmation",
      "Content-Rename-Confirmation":
        "Si vous modifiez une extension de nom de fichier, le fichier peut devenir instable. Voulez-vous vraiment le modifier ?",
      "Header-Delete": "Supprimer le fichier",
      "Content-Delete": "Voulez-vous vraiment supprimer ce fichier ?",
      "Header-Folder-Delete": "Supprimer le dossier",
      "Content-Folder-Delete":
        "Êtes-vous sûr de vouloir supprimer ce dossier ?",
      "Header-Multiple-Delete": "Supprimer plusieurs fichiers",
      "Content-Multiple-Delete":
        "Voulez-vous vraiment supprimer ces {0} fichiers ?",
      "Header-Duplicate": "Le fichier / dossier existe",
      "Content-Duplicate": "{0} existe déjà. Voulez-vous renommer et coller ?",
      "Header-Upload": "Téléverser des fichiers",
      Error: "Erreur",
      "Validation-Empty":
        "Le nom du fichier ou du dossier ne peut pas être vide.",
      "Validation-Invalid":
        'Le nom de fichier ou de dossier {0} contient des caractères non valides. Veuillez utiliser un nom différent. Les noms de fichiers ou de dossiers valides ne peuvent pas se terminer par un point ou un espace et ne peuvent contenir aucun des caractères suivants: \\ /: *? "<> |',
      "Validation-NewFolder-Exists":
        "Un fichier ou un dossier portant le nom {0} existe déjà.",
      "Validation-Rename-Exists":
        "Impossible de renommer {0} en {1} : la destination existe déjà.",
      "Folder-Empty": "Ce dossier est vide",
      "File-Upload": "Glissez les fichiers ici pour les téléverser",
      "Search-Empty": "Aucun résultat trouvé",
      "Search-Key": "Essayez avec différents mots clés",
      "Filter-Empty": "Aucun résultat trouvé",
      "Filter-Key": "Essayez avec un filtre différent",
      "Sub-Folder-Error":
        "Le dossier de destination est le sous-dossier du dossier source.",
      "Same-Folder-Error":
        "Le dossier de destination est identique au dossier source.",
      "Access-Denied": "Accès refusé",
      "Access-Details": "Vous n'avez pas la permission d'accéder à ce dossier.",
      "Header-Retry": "Le fichier existe déjà",
      "Content-Retry":
        "Un fichier avec ce nom existe déjà dans ce dossier. Que souhaitez-vous faire ?",
      "Button-Keep-Both": "Conserver les deux",
      "Button-Replace": "Remplacer",
      "Button-Skip": "Ignorer",
      "ApplyAll-Label": "Faire ceci pour tous les éléments actuels",
      KB: "Ko",
      "Access-Message":
        "{0} n'est pas accessible. Vous avez besoin de la permission pour effectuer l'action {1}.",
      "Network-Error":
        "NetworkError: échec d'envoi sur XMLHTTPRequest: échec de chargement",
      "Server-Error": "Erreur serveur : réponse non valide de",
    },
    calendar: {
      today: "Aujourd'hui",
    },
    datepicker: {
      today: "Aujourd'hui",
      placeholder: "Choisissez une date",
    },
    daterangepicker: {
      placeholder: "Choisissez une plage de dates",
      startLabel: "Date de début",
      endLabel: "Date de fin",
      applyText: "Appliquer",
      cancelText: "Annuler",
      selectedDays: "Jours sélectionnés",
      days: "Jours",
      customRange: "Période personnalisée",
    },
    timepicker: {
      placeholder: "Choisissez une heure",
    },
    datetimepicker: {
      today: "Aujourd'hui",
      placeholder: "Choisissez une date et une heure",
    },
    dialog: {
      close: "Fermer",
    },
    toast: {
      close: "Fermer",
    },
    tab: {
      closeButtonTitle: "Fermer",
    },
    schedule: {
      day: "Jour",
      week: "Semaine",
      workWeek: "Semaine de travail",
      month: "Mois",
      year: "Année",
      agenda: "Ordre du jour",
      weekAgenda: "Ordre du jour de la semaine",
      workWeekAgenda: "Ordre du jour de la semaine de travail",
      monthAgenda: "Ordre du jour du mois",
      today: "Aujourd'hui",
      noEvents: "Aucun événement",
      emptyContainer: "Aucun événement n'est prévu ce jour.",
      allDay: "Toute la journée",
      start: "Début",
      end: "Fin",
      more: "plus",
      close: "Fermer",
      cancel: "Annuler",
      noTitle: "(Pas de titre)",
      delete: "Supprimer",
      deleteEvent: "Supprimer l'événement",
      deleteMultipleEvent: "Supprimer plusieurs événements",
      selectedItems: "Éléments sélectionnés",
      deleteSeries: "Supprimer la série",
      edit: "Modifier",
      editSeries: "Modifier la série",
      editEvent: "Modifier l'événement",
      createEvent: "Créer",
      subject: "Sujet",
      addTitle: "Ajouter un titre",
      moreDetails: "Plus de détails",
      moreEvents: "Plus d'événements",
      save: "Enregistrer",
      editContent:
        "Comment souhaitez-vous modifier le rendez-vous dans la série ?",
      deleteContent: "Êtes-vous sûr de vouloir supprimer cet événement ?",
      deleteMultipleContent:
        "Êtes-vous sûr de vouloir supprimer les événements sélectionnés ?",
      newEvent: "Nouvel événement",
      title: "Titre",
      location: "Emplacement",
      description: "Description",
      timezone: "Fuseau horaire",
      startTimezone: "Fuseau horaire de début",
      endTimezone: "Fuseau horaire de fin",
      repeat: "Répéter",
      saveButton: "Enregistrer",
      cancelButton: "Annuler",
      deleteButton: "Supprimer",
      recurrence: "Récurrence",
      wrongPattern: "Le modèle de récurrence n'est pas valide.",
      seriesChangeAlert:
        "Voulez-vous annuler les modifications apportées à des instances spécifiques de cette série et les faire correspondre à nouveau à l'ensemble de la série ?",
      createError:
        "La durée de l'événement doit être plus courte que sa fréquence. Raccourcissez la durée ou modifiez le modèle de récurrence dans l'éditeur d'événements de récurrence.",
      sameDayAlert:
        "Deux occurrences du même événement ne peuvent pas avoir lieu le même jour.",
      occurenceAlert:
        "Impossible de replanifier une occurrence du rendez-vous périodique si elle ignore une occurrence ultérieure du même rendez-vous.",
      editRecurrence: "Modifier la récurrence",
      repeats: "Se répète",
      alert: "Alerte",
      startEndError:
        "La date de fin sélectionnée se produit avant la date de début.",
      invalidDateError: "La valeur de date saisie n'est pas valide.",
      blockAlert:
        "Les événements ne peuvent pas être planifiés dans l'intervalle de temps bloqué.",
      ok: "OK",
      of: "de",
      yes: "Oui",
      no: "Non",
      occurrence: "Occurrence",
      series: "Série",
      previous: "Précédent",
      next: "Prochain",
      timelineDay: "Chronologie du jour",
      timelineWeek: "Chronologie de la semaine",
      timelineWorkWeek: "Chronologie de la semaine de travail",
      timelineMonth: "Chronologie du mois",
      timelineYear: "Chronologie de l'année",
      editFollowingEvent: "Événements suivants",
      deleteTitle: "Supprimer l'événement",
      editTitle: "Modifier l'événement",
      beginFrom: "Commencer à partir de",
      endAt: "Fin à",
      expandAllDaySection: "Développer la section de toute la journée",
      collapseAllDaySection: "Réduire la section de toute la journée",
      searchTimezone: "Rechercher un fuseau horaire",
      noRecords: "Aucun enregistrement trouvé",
      deleteRecurrenceContent:
        "Voulez-vous supprimer uniquement cet événement ou toute la série?",
      recurrenceDateValidation:
        "Certains mois ont moins de jours que la date sélectionnée. Pour ces mois, l'événement aura lieu le dernier jour du mois.",
    },
    recurrenceeditor: {
      none: "Aucun",
      daily: "Quotidien",
      weekly: "Hebdomadaire",
      monthly: "Mensuel",
      month: "Mois",
      yearly: "Annuel",
      never: "Jamais",
      until: "Jusqu'à",
      count: "Compter",
      first: "Premier",
      second: "Deuxième",
      third: "Troisième",
      fourth: "Quatrième",
      last: "Dernier",
      repeat: "Répéter",
      repeatEvery: "Répétez chaque",
      on: "Répéter sur",
      end: "Fin",
      onDay: "Jour",
      days: "Jour(s)",
      weeks: "Semaine(s)",
      months: "Mois",
      years: "Année(s)",
      every: "chaque",
      summaryTimes: "fois",
      summaryOn: "sur",
      summaryUntil: "jusqu'au",
      summaryRepeat: "Répétitions",
      summaryDay: "jour(s)",
      summaryWeek: "semaine(s)",
      summaryMonth: "mois",
      summaryYear: "année(s)",
      monthWeek: "Mois Semaine",
      monthPosition: "Position du mois",
      monthExpander: "Expander mois",
      yearExpander: "Expander année",
      repeatInterval: "Intervalle de répétition",
    },
    gantt: {
      emptyRecord: "Aucun enregistrement à afficher",
      id: "ID",
      name: "Nom",
      startDate: "Date de début",
      endDate: "Date de fin",
      duration: "Durée",
      progress: "Progression",
      dependency: "Dépendance",
      notes: "Notes",
      baselineStartDate: "Date de début de référence",
      baselineEndDate: "Date de fin de référence",
      taskMode: "Mode de tâche",
      changeScheduleMode: "Changer le mode de programmation",
      subTasksStartDate: "Date de début des sous-tâches",
      subTasksEndDate: "Date de fin des sous-tâches",
      scheduleStartDate: "Date de début du calendrier",
      scheduleEndDate: "Date de fin du calendrier",
      auto: "Automatique",
      manual: "Manuel",
      type: "Taper",
      offset: "Décalage",
      resourceName: "Ressources",
      resourceID: "ID de ressource",
      day: "jour",
      hour: "heure",
      minute: "minute",
      days: "jours",
      hours: "heures",
      minutes: "minutes",
      generalTab: "Général",
      customTab: "Colonnes personnalisées",
      writeNotes: "Écrire des notes",
      addDialogTitle: "Nouvelle tâche",
      editDialogTitle: "Informations sur la tâche",
      saveButton: "Enregistrer",
      add: "Ajouter",
      edit: "Éditer",
      update: "Mise à jour",
      delete: "Supprimer",
      cancel: "Annuler",
      search: "Recherche",
      task: " tâche",
      tasks: " tâches",
      zoomIn: "Agrandir",
      zoomOut: "Dézoomer",
      zoomToFit: "Zoom pour ajuster",
      excelExport: "Exportation Excel",
      csvExport: "Exportation CSV",
      expandAll: "Tout développer",
      collapseAll: "Réduire tout",
      nextTimeSpan: "Plage de temps suivante",
      prevTimeSpan: "Plage de temps précédente",
      okText: "OK",
      confirmDelete: "Êtes-vous sûr de vouloir supprimer l'enregistrement ?",
      from: "De",
      to: "À",
      taskLink: "Lien de tâche",
      lag: "Décalage",
      start: "Début",
      finish: "terminer",
      enterValue: "Entrez la valeur",
      taskBeforePredecessor_FS:
        "Vous avez déplacé «{0}» pour commencer avant la fin de «{1}» et les deux tâches sont liées. Par conséquent, les liens ne peuvent pas être honorés. Sélectionnez une action ci-dessous pour effectuer",
      taskAfterPredecessor_FS:
        "Vous avez déplacé '{0}' de '{1}' et les deux tâches sont liées. Par conséquent, les liens ne peuvent pas être honorés. Sélectionnez une action ci-dessous pour effectuer",
      taskBeforePredecessor_SS:
        "Vous avez déplacé '{0}' pour démarrer avant le démarrage de '{1}' et les deux tâches sont liées. Par conséquent, les liens ne peuvent pas être honorés. Sélectionnez une action ci-dessous pour effectuer",
      taskAfterPredecessor_SS:
        "Vous avez déplacé '{0}' pour démarrer après le démarrage de '{1}' et les deux tâches sont liées. Par conséquent, les liens ne peuvent pas être honorés. Sélectionnez une action ci-dessous pour effectuer",
      taskBeforePredecessor_FF:
        "Vous avez déplacé '{0}' pour terminer avant la fin de '{1}' et les deux tâches sont liées. Par conséquent, les liens ne peuvent pas être honorés. Sélectionnez une action ci-dessous pour effectuer",
      taskAfterPredecessor_FF:
        "Vous avez déplacé «{0}» pour terminer une fois «{1}» terminé et les deux tâches sont liées. Par conséquent, les liens ne peuvent pas être honorés. Sélectionnez une action ci-dessous pour effectuer",
      taskBeforePredecessor_SF:
        "Vous avez déplacé '{0}' de '{1}' vers le début et les deux tâches sont liées. Par conséquent, les liens ne peuvent pas être honorés. Sélectionnez une action ci-dessous pour effectuer",
      taskAfterPredecessor_SF:
        "Vous avez déplacé '{0}' pour terminer après le démarrage de '{1}' et les deux tâches sont liées. Par conséquent, les liens ne peuvent pas être honorés. Sélectionnez une action ci-dessous pour effectuer",
      taskInformation: "Informations sur la tâche",
      deleteTask: "Supprimer la tâche",
      deleteDependency: "Supprimer la dépendance",
      convert: "Convertir",
      save: "Enregistrer",
      above: "Au-dessus",
      below: "Au-dessous",
      child: "Enfant",
      milestone: "Jalon",
      toTask: "À la tâche",
      toMilestone: "Vers le jalon",
      eventMarkers: "Marqueurs d'événements",
      leftTaskLabel: "Étiquette de tâche gauche",
      rightTaskLabel: "Étiquette de tâche droite",
      timelineCell: "Cellule de la chronologie",
      confirmPredecessorDelete:
        "Voulez-vous vraiment supprimer le lien de dépendance ?",
      unit: "Unité",
      work: "Travail",
      taskType: "Type de tâche",
      unassignedTask: "Tâche non attribuée",
      group: "Grouper",
      indent: "Indenter",
      outdent: "Désindenter",
      segments: "Segments",
      splitTask: "Diviser la tâche",
      mergeTask: "Fusionner la tâche",
      left: "Gauche",
      right: "Droite",
      FF: "FR",
      FS: "FS",
      SF: "SF",
      SS: "SS",
    },
    richtexteditor: {
      alignments: "Alignements",
      justifyLeft: "Alignez à gauche",
      justifyCenter: "Aligner le centre",
      justifyRight: "Aligner à droite",
      justifyFull: "Aligner Justifier",
      fontName: "Nom de police",
      fontSize: "Taille de police",
      fontColor: "Couleur de la police",
      backgroundColor: "Couleur de l'arrière plan",
      bold: "Audacieux",
      italic: "Italique",
      underline: "Souligner",
      strikethrough: "Barré",
      clearFormat: "Effacer le format",
      clearAll: "Tout effacer",
      cut: "Couper",
      copy: "Copier",
      paste: "Coller",
      unorderedList: "Liste à puces",
      orderedList: "Liste numérotée",
      indent: "Augmenter le retrait",
      outdent: "Diminuer le retrait",
      undo: "annuler",
      redo: "Refaire",
      superscript: "Exposant",
      subscript: "Indice",
      createLink: "Insérer un lien hypertexte",
      openLink: "Ouvrir le lien",
      editLink: "Modifier le lien",
      removeLink: "Supprimer le lien",
      image: "Insérer une image",
      replace: "Remplacer",
      numberFormatList: "Liste des formats de nombres",
      bulletFormatList: "Liste des formats de puces",
      audioReplace: "Remplacer",
      videoReplace: "Remplacer",
      videoAlign: "Aligner",
      videoDimension: "Dimension",
      audioRemove: "Retirer",
      videoRemove: "Retirer",
      audioLayoutOption: "Option de mise en page",
      videoLayoutOption: "Option de mise en page",
      align: "Aligner",
      caption: "Légende",
      remove: "Retirer",
      insertLink: "Insérer un lien",
      display: "Afficher",
      altText: "Texte alternatif",
      dimension: "Changer la taille",
      fullscreen: "Maximiser",
      maximize: "Maximiser",
      minimize: "Minimiser",
      lowerCase: "Minuscules",
      upperCase: "Majuscules",
      print: "Impression",
      formats: "Formats",
      sourcecode: "Affichage du code",
      preview: "Aperçu",
      viewside: "VueCôté",
      insertCode: "Insérer le code",
      linkText: "Afficher le texte",
      linkTooltipLabel: "Titre",
      linkWebUrl: "Adresse web",
      linkTitle: "Entrez un titre",
      linkurl: "https://exemple.com",
      linkOpenInNewWindow: "Ouvre le lien dans une nouvelle fenêtre",
      linkHeader: "Insérer un lien",
      dialogInsert: "Insérer",
      dialogCancel: "Annuler",
      dialogUpdate: "Mise à jour",
      imageHeader: "Insérer une image",
      audioHeader: "Insérer un audio",
      videoHeader: "Insérer une vidéo",
      imageLinkHeader: "Vous pouvez également fournir un lien à partir du Web",
      audioLinkHeader: "Vous pouvez également fournir un lien depuis le Web",
      videoLinkHeader: "URL Web",
      embedVideoLinkHeader: "URL d'intégration du média",
      mdimageLink: "Veuillez fournir une URL pour votre image",
      imageUploadMessage: "Déposez l'image ici ou parcourez pour télécharger",
      audioUploadMessage:
        "Déposez un fichier audio ou parcourez pour le télécharger",
      videoUploadMessage:
        "Déposez un fichier vidéo ou parcourez pour le télécharger",
      imageDeviceUploadMessage: "Cliquez ici pour télécharger",
      audioDeviceUploadMessage: "Cliquez ici pour télécharger",
      videoDeviceUploadMessage: "Cliquez ici pour télécharger",
      imageAlternateText: "Texte alternatif",
      alternateHeader: "Texte alternatif",
      browse: "Parcourir",
      imageUrl: "https://example.com/image.png",
      audioUrl: "https://exemple.com/audio.mp3",
      videoUrl: "https://exemple.com/video.mp4",
      webUrl: "URL Web",
      embedUrl: "Code intégré",
      imageCaption: "Légende",
      imageSizeHeader: "Taille de l'image",
      imageHeight: "la taille",
      imageWidth: "Largeur",
      videoHeight: "Hauteur",
      videoWidth: "Largeur",
      textPlaceholder: "Entrez du texte",
      inserttablebtn: "Insérer un tableau",
      tabledialogHeader: "Insérer un tableau",
      tableWidth: "Largeur",
      cellpadding: "Rembourrage cellulaire",
      cellspacing: "Espacement des cellules",
      columns: "Le nombre de colonnes",
      rows: "Nombre de rangées",
      tableRows: "Rangée",
      tableColumns: "Colonne",
      tableCellHorizontalAlign: "Alignement horizontal des cellules du tableau",
      tableCellVerticalAlign: "Alignement vertical du tableau",
      createTable: "Créer une table",
      removeTable: "Supprimer le tableau",
      tableHeader: "Ligne d'en-tête",
      tableRemove: "Supprimer le tableau",
      tableCellBackground: "Fond de cellule de tableau",
      tableEditProperties: "Propriétés de modification du tableau",
      styles: "modes",
      insertColumnLeft: "Insérer une colonne à gauche",
      insertColumnRight: "Insérer une colonne à droite",
      deleteColumn: "Supprimer la colonne",
      insertRowBefore: "Insérer une ligne avant",
      insertRowAfter: "Insérer une ligne après",
      deleteRow: "Supprimer la ligne",
      tableEditHeader: "Modifier le tableau",
      TableHeadingText: "Titre",
      TableColText: "Col",
      imageInsertLinkHeader: "Insérer un lien",
      editImageHeader: "Éditer l'image",
      alignmentsDropDownLeft: "Alignez à gauche",
      alignmentsDropDownCenter: "Aligner le centre",
      alignmentsDropDownRight: "Aligner à droite",
      alignmentsDropDownJustify: "Aligner Justifier",
      imageDisplayDropDownInline: "En ligne",
      imageDisplayDropDownBreak: "Pause",
      audioLayoutOptionDropDownInline: "En ligne",
      audioLayoutOptionDropDownBreak: "Casser",
      videoLayoutOptionDropDownInline: "En ligne",
      videoLayoutOptionDropDownBreak: "Casser",
      tableInsertRowDropDownBefore: "Insérer une ligne avant",
      tableInsertRowDropDownAfter: "Insérer une ligne après",
      tableInsertRowDropDownDelete: "Supprimer la ligne",
      tableInsertColumnDropDownLeft: "Insérer la colonne à gauche",
      tableInsertColumnDropDownRight: "Insérer une colonne à droite",
      tableInsertColumnDropDownDelete: "Supprimer la colonne",
      tableVerticalAlignDropDownTop: "Aligner en haut",
      tableVerticalAlignDropDownMiddle: "Aligner au milieu",
      tableVerticalAlignDropDownBottom: "Aligner en bas",
      tableStylesDropDownDashedBorder: "Bordures pointillées",
      tableStylesDropDownAlternateRows: "Lignes alternatives",
      pasteFormat: "Coller le format",
      pasteFormatContent: "Choisissez l'action de formatage",
      plainText: "Texte brut",
      cleanFormat: "Nettoyer",
      keepFormat: "Garder",
      pasteDialogOk: "D'accord",
      pasteDialogCancel: "Annuler",
      fileManager: "Gestionnaire de fichiers",
      fileDialogHeader: "Navigateur de fichiers",
      formatsDropDownParagraph: "Paragraphe",
      formatsDropDownCode: "Code",
      formatsDropDownQuotation: "Devis",
      formatsDropDownHeading1: "Titre 1",
      formatsDropDownHeading2: "Titre 2",
      formatsDropDownHeading3: "Titre 3",
      formatsDropDownHeading4: "Titre 4",
      fontNameSegoeUI: "SegoeUI",
      fontNameArial: "Arial",
      fontNameGeorgia: "Georgia",
      fontNameImpact: "Impact",
      fontNameTahoma: "Tahoma",
      fontNameTimesNewRoman: "Times New Roman",
      fontNameVerdana: "Verdana",
      formatsOLListNumber: "Nombre",
      formatsOLListLowerAlpha: "Alpha inférieur",
      formatsOLListUpperAlpha: "Alpha supérieur",
      formatsOLListLowerRoman: "Bas-Romain",
      formatsOLListUpperRoman: "Haut-Romain",
      formatsOLListLowerGreek: "bas grec",
      formatsULListDisc: "Disque",
      formatsULListCircle: "Cercle",
      formatsULListSquare: "Carré",
      formatsOLListNone: "Rien",
      formatsULListNone: "Rien",
      formatPainter: "Peintre de format",
      emojiPicker: "Sélecteur d'émoticônes",
      embeddedCode: "Code intégré",
      pasteEmbeddedCodeHere: "Collez le code intégré ici",
      emojiPickerTypeToFind: "Tapez pour trouver",
      emojiPickerNoResultFound: "Aucun résultat trouvé",
      emojiPickerTrySomethingElse: "Essayez autre chose",
      linkAriaLabel: "Ouvrir dans une nouvelle fenêtre",
      imageLinkAriaLabel: "Ouvrir dans une nouvelle fenêtre",
      unsupportedImage: "Format de fichier non pris en charge",
      mergecells: "Fusionner des cellules",
      verticalsplit: "Division verticale",
      horizontalsplit: "Division horizontale",
      numberFormatListNumber: "Nombre",
      numberFormatListLowerAlpha: "Alpha inférieur",
      numberFormatListUpperAlpha: "Alpha supérieur",
      numberFormatListLowerRoman: "Bas-romain",
      numberFormatListUpperRoman: "Haut-romain",
      numberFormatListLowerGreek: "Grec inférieur",
      bulletFormatListDisc: "Disque",
      bulletFormatListCircle: "Cercle",
      bulletFormatListSquare: "Carré",
      numberFormatListNone: "Rien",
      bulletFormatListNone: "Rien",
      slashMenuItemHeadingOneText: "Titre 1",
      slashMenuItemHeadingOneDescription:
        "Utilisez-le pour un en-tête ou un titre de niveau supérieur.",
      slashMenuItemHeadingTwoText: "Titre 2",
      slashMenuItemHeadingTwoDescription: "Utilisez-le pour les sections clés.",
      slashMenuItemHeadingThreeText: "Titre 3",
      slashMenuItemHeadingThreeDescription:
        "Utilisez-le pour les sous-sections et les titres de groupe.",
      slashMenuItemHeadingFourText: "Titre 4",
      slashMenuItemHeadingFourDescription:
        "Utilisez-le pour les points clés des sous-thèmes.",
      slashMenuItemParagraphText: "Paragraphe",
      slashMenuItemParagraphDescription: "Écrire avec des paragraphes.",
      slashMenuItemBlockquoteText: "Citation de bloc",
      slashMenuItemBlockquoteDescription: "Créez une citation ou une citation.",
      slashMenuItemOrderedListText: "Liste ordonnée",
      slashMenuItemOrderedListDescription: "Créez une liste ordonnée.",
      slashMenuItemUnorderedListText: "Liste non ordonnée",
      slashMenuItemUnorderedListDescription: "Créez une liste non ordonnée.",
      slashMenuItemCodeText: "Bloc de code",
      slashMenuItemCodeDescription: "Créez un bloc de code préformaté.",
      slashMenuItemTableText: "Tableau",
      slashMenuItemTableDescription: "Insérez un tableau.",
      slashMenuItemLinkText: "Lien",
      slashMenuItemLinkDescription: "Insérez un lien.",
      slashMenuItemImageText: "Image",
      slashMenuItemImageDescription: "Insérez une image.",
      slashMenuItemAudioText: "Audio",
      slashMenuItemAudioDescription: "Insérez un audio.",
      slashMenuItemVideoText: "Vidéo",
      slashMenuItemVideoDescription: "Insérez une vidéo.",
      slashMenuItemEmojiText: "Sélecteur d'Emoji",
      slashMenuItemEmojiDescription:
        "Utilisez des émojis pour exprimer des idées et des émoticônes.",
    },
    colorpicker: {
      Apply: "Appliquer",
      Cancel: "Annuler",
      ModeSwitcher: "Commutateur de mode",
      RecentColors: "Couleurs récentes",
    },
    uploader: {
      Browse: "Parcourir...",
      Clear: "Effacer",
      Upload: "Téléverser",
      dropFilesHint: "Ou déposer des fichiers ici",
      invalidMaxFileSize: "La taille du fichier est trop grande",
      invalidMinFileSize: "La taille du fichier est trop petite",
      invalidFileType: "Le type de fichier n'est pas autorisé",
      uploadFailedMessage: "Le fichier n'a pas pu être téléversé",
      uploadSuccessMessage: "Fichier téléversé avec succès",
      removedSuccessMessage: "Fichier retiré avec succès",
      removedFailedMessage: "Impossible de retirer le fichier",
      inProgress: "Téléversement en cours",
      readyToUploadMessage: "Prêt à téléverser",
      abort: "Annuler",
      remove: "Retirer",
      cancel: "Annuler",
      delete: "Supprimer le fichier",
      pauseUpload: "Téléversement du fichier en pause",
      pause: "Pause",
      resume: "Reprendre",
      retry: "Réessayer",
      fileUploadCancel: "Téléversement du fichier annulé",
    },
    numerictextbox: {
      incrementTitle: "Incrémenter la valeur",
      decrementTitle: "Décrémenter la valeur",
    },
    slider: {
      incrementTitle: "Augmenter",
      decrementTitle: "Diminuer",
    },
    formValidator: {
      required: "Ce champ est requis.",
      email: "Veuillez saisir une adresse email valide.",
      url: "Veuillez saisir une URL valide.",
      date: "Veuillez entrer une date valide.",
      dateIso: "Veuillez saisir une date valide (ISO).",
      creditcard: "Veuillez entrer un numéro de carte valide",
      number: "Veuillez entrer un nombre valide.",
      digits: "Merci de n'entrer que des chiffres.",
      maxLength: "Veuillez ne pas saisir plus de {0} caractères.",
      minLength: "Veuillez saisir au moins {0} caractères.",
      rangeLength:
        "Veuillez saisir une valeur comprise entre {0} et {1} caractères.",
      range: "Veuillez saisir une valeur comprise entre {0} et {1}.",
      max: "Veuillez saisir une valeur inférieure ou égale à {0}.",
      min: "Veuillez saisir une valeur supérieure ou égale à {0}.",
      regex: "Veuillez saisir une valeur correcte.",
      tel: "Veuillez entrer un numéro de téléphone valide.",
      pattern: "Veuillez saisir une valeur de motif correcte.",
      equalTo: "Veuillez saisir le texte de correspondance valide",
    },
    treegrid: {
      Above: "Au-dessus",
      Below: "En-dessous",
      AddRow: "Ajouter une ligne",
      ExpandAll: "Tout développer",
      CollapseAll: "Tout réduire",
    },
    querybuilder: {
      StartsWith: "Commence avec",
      EndsWith: "Se termine par",
      Contains: "Contient",
      NotLike: "Pas comme",
      Like: "Comme",
      Equal: "Égal",
      NotEqual: "Non égal",
      LessThan: "Moins que",
      LessThanOrEqual: "Inférieur ou égal",
      GreaterThan: "Plus grand que",
      GreaterThanOrEqual: "Supérieur ou égal",
      Between: "Entre",
      NotBetween: "Pas entre",
      Empty: "Vide",
      NotEmpty: "Non vide",
      In: "Dans",
      NotIn: "Pas dans",
      NotContains: "Ne contient pas",
      Remove: "ENLEVER",
      SelectField: "Sélectionnez un champ",
      SelectOperator: "Sélectionnez un opérateur",
      DeleteRule: "Supprimer cette condition",
      DeleteGroup: "Supprimer le groupe",
      AddGroup: "Ajouter un groupe",
      AddCondition: "Ajouter une condition",
      Edit: "ÉDITER",
      ValidationMessage: "Ce champ est requis",
      SummaryViewTitle: "Vue récapitulative",
      OtherFields: "Autres champs",
      AND: "ET",
      OR: "OU",
      SelectValue: "Entrez une valeur",
      IsEmpty: "Est vide",
      IsNotEmpty: "N'est pas vide",
      IsNull: "Est nul",
      IsNotNull: "N'est pas nul",
      True: "vrai",
      False: "faux",
      DoesNotStartWith: "Ne commence pas par",
      DoesNotEndWith: "Ne se termine pas par",
      DoesNotContain: "Ne contient pas",
      AddButton: "Ajouter un groupe/une condition",
      CloneGroup: "Cloner le groupe",
      LockGroup: "Verrouiller le groupe",
      CloneRule: "Cloner la règle",
      LockRule: "Verrouiller la règle",
      UnlockRule: "Règle de déverrouillage",
      UnlockGroup: "Déverrouiller le groupe",
      NOT: "Pas",
    },
    barcode: {},
    datamatrix: {},
    qrcode: {},
    pivotview: {
      applyToGrandTotal: "Appliquer au Grand Total",
      grandTotal: "Grand total",
      total: "Total",
      value: "Valeur",
      noValue: "Aucune valeur",
      row: "Ligne",
      column: "Colonne",
      collapse: "Réduire",
      expand: "Développer",
      rowAxisPrompt: "Déposer les lignes ici",
      columnAxisPrompt: "Déposer les colonne ici",
      valueAxisPrompt: "Déposer les valeurs ici",
      filterAxisPrompt: "Déposer le filtre ici",
      filter: "Filtrer",
      filtered: "Filtré",
      sort: "Trier",
      filters: "Filtres",
      rows: "Lignes",
      columns: "Colonnes",
      values: "Valeurs",
      close: "Fermer",
      cancel: "Annuler",
      delete: "Supprimer",
      CalculatedField: "Champ calculé",
      createCalculatedField: "Créer un champ calculé",
      fieldName: "Entrez le nom du champ",
      error: "Erreur",
      invalidFormula: "Formule non valide.",
      dropText: "Exemple : ('Somme (Order_Count)' + 'Somme (In_Stock)') * 250",
      dropTextMobile: "Ajoutez des champs et modifiez la formule ici.",
      dropAction:
        "Le champ calculé ne peut être placé dans aucune autre région à l'exception de l'axe des valeurs.",
      alert: "Alerte",
      warning: "Avertissement",
      ok: "OK",
      search: "Rechercher",
      drag: "Glisser",
      remove: "Retirer",
      allFields: "Tous les champs",
      formula: "Formule",
      addToRow: "Ajouter à la ligne",
      addToColumn: "Ajouter à la colonne",
      addToValue: "Ajouter à la valeur",
      addToFilter: "Ajouter au filtre",
      emptyData: "Aucun enregistrement à afficher",
      fieldExist:
        "Un champ existe déjà sous ce nom. Veuillez saisir un nom différent.",
      confirmText:
        "Un champ de calcul existe déjà sous ce nom. Voulez-vous le remplacer ?",
      noMatches: "Pas de correspondance",
      format: "Résume les valeurs par",
      edit: "Éditer",
      clear: "Clair",
      formulaField: "Glissez et déposez les champs dans la formule",
      dragField: "Faites glisser le champ vers la formule",
      clearFilter: "Effacer les filtres",
      by: "par",
      all: "Tout",
      multipleItems: "Articles multiples",
      member: "Membre",
      label: "Étiquette",
      date: "Date",
      enterValue: "Entrez une valeur",
      chooseDate: "Entrez la date",
      Before: "Avant",
      BeforeOrEqualTo: "Avant ou égal à",
      After: "Après",
      AfterOrEqualTo: "Après ou égal à",
      labelTextContent: "Afficher les éléments pour lesquels l'étiquette",
      dateTextContent: "Afficher les articles pour lesquels la date",
      valueTextContent: "Afficher les éléments pour lesquels",
      Equals: "Équivaut à",
      DoesNotEquals: "N'est pas égal",
      BeginWith: "Commence par",
      DoesNotBeginWith: "Ne commence pas par",
      EndsWith: "Se termine par",
      DoesNotEndsWith: "Ne se termine pas par",
      Contains: "Contient",
      DoesNotContains: "Ne contient pas",
      GreaterThan: "Plus grand que",
      GreaterThanOrEqualTo: "Plus grand ou égal à",
      LessThan: "Moins que",
      LessThanOrEqualTo: "Inférieur ou égal à",
      Between: "Entre",
      NotBetween: "Pas entre",
      And: "et",
      Sum: "Somme",
      Count: "Compter",
      DistinctCount: "Nombre distinct",
      Product: "Produit",
      Avg: "Moyenne.",
      Min: "Min",
      SampleVar: "Échantillon Var",
      PopulationVar: "Population Var",
      RunningTotals: "Totaux en cours d'exécution",
      Max: "Max",
      Index: "Indice",
      SampleStDev: "Exemple StDev",
      PopulationStDev: "La population de StDev",
      PercentageOfRowTotal: "% du total des lignes",
      PercentageOfParentTotal: "% du total des parents",
      PercentageOfParentColumnTotal: "% du total de la colonne parent",
      PercentageOfParentRowTotal: "% du total de la ligne parent",
      DifferenceFrom: "Différence de",
      PercentageOfDifferenceFrom: "% de différence par rapport à",
      PercentageOfGrandTotal: "% du grand total",
      PercentageOfColumnTotal: "% du total de la colonne",
      NotEquals: "Pas égal",
      AllValues: "Toutes les valeurs",
      conditionalFormatting: "Mise en forme conditionnelle",
      apply: "APPLIQUER",
      condition: "Ajouter une condition",
      formatLabel: "Format",
      valueFieldSettings: "Paramètres de champ de valeur",
      baseField: "Champ de base:",
      baseItem: "Élément de base:",
      summarizeValuesBy: "Résumez les valeurs en:",
      sourceName: "Nom de domaine :",
      sourceCaption: "Légende du champ:",
      example: "par exemple:",
      editorDataLimitMsg:
        " Plus d'articles. Recherchez pour affiner davantage.",
      details: "Détails",
      manageRecords: "Gérer les enregistrements",
      Years: "Ans",
      Quarters: "Quartiers",
      Months: "Mois",
      Days: "Journées",
      Hours: "Heures",
      Minutes: "Minutes",
      Seconds: "Secondes",
      save: "Enregistrer un rapport",
      new: "Créer un nouveau rapport",
      load: "Charger",
      saveAs: "Enregistrer en tant que rapport actuel",
      rename: "Renommer un rapport actuel",
      deleteReport: "Supprimer un rapport actuel",
      export: "Exportation",
      subTotals: "Sous-totaux",
      grandTotals: "Totaux généraux",
      reportName: "Nom du rapport:",
      pdf: "PDF",
      excel: "Excel",
      csv: "CSV",
      png: "PNG",
      jpeg: "JPEG",
      svg: "SVG",
      mdxQuery: "Requête MDX",
      showSubTotals: "Afficher les sous-totaux",
      doNotShowSubTotals: "Ne pas afficher les sous-totaux",
      showSubTotalsRowsOnly: "Afficher uniquement les lignes de sous-totaux",
      showSubTotalsColumnsOnly:
        "Afficher uniquement les colonnes de sous-totaux",
      showGrandTotals: "Afficher les totaux généraux",
      doNotShowGrandTotals: "Ne pas afficher les totaux généraux",
      showGrandTotalsRowsOnly:
        "Afficher uniquement les lignes des totaux généraux",
      showGrandTotalsColumnsOnly:
        "Afficher uniquement les colonnes des totaux généraux",
      fieldList: "Afficher la liste des champs",
      grid: "Afficher le tableau",
      toolbarFormatting: "Mise en forme conditionnelle",
      chart: "Graphique",
      reportMsg: "Veuillez entrer un nom de rapport valide !!!",
      reportList: "Liste des rapports",
      removeConfirm: "Voulez-vous vraiment supprimer ce rapport ?",
      emptyReport: "Aucun rapport trouvé !",
      bar: "Barre",
      line: "Ligne",
      area: "Zone",
      scatter: "Dispersion",
      polar: "Polaire",
      of: "de",
      emptyFormat: "Aucun format trouvé !",
      emptyInput: "Entrez une valeur",
      newReportConfirm:
        "Vous souhaitez enregistrer les modifications à signaler ?",
      emptyReportName: "Entrez un nom de rapport",
      qtr: "Trimestre",
      null: "nul",
      undefined: "indéfini",
      groupOutOfRange: "Hors de portée",
      fieldDropErrorAction:
        "Le champ que vous déplacez ne peut pas être placé dans cette zone du rapport",
      MoreOption: "Plus...",
      aggregate: "Agrégat",
      drillThrough: "Afficher le détail",
      ascending: "Ascendant",
      descending: "Descendant",
      number: "Nombre",
      currency: "Devise",
      percentage: "Pourcentage",
      formatType: "Type de format",
      customText: "Symbole de la monnaie",
      symbolPosition: "Position du symbole",
      left: "Gauche",
      right: "Droite",
      grouping: "Regroupement",
      true: "Vrai",
      false: "Faux",
      decimalPlaces: "Décimales",
      numberFormat: "Formatage des nombres",
      memberType: "Type de champ",
      formatString: "Format de chaîne",
      expressionField: "Expression",
      customFormat: "Entrez une chaîne de format personnalisé",
      selectedHierarchy: "Hiérarchie parente",
      olapDropText:
        "Exemple: [Mesures]. [Quantité de commande] + ([Mesures]. [Quantité de commande] * 0,10)",
      Percent: "Pour cent",
      Custom: "Personnalisé",
      Measure: "Mesure",
      Dimension: "Dimension",
      Standard: "Standard",
      blank: "(Vide)",
      fieldTooltip:
        "Faites glisser et déposez les champs pour créer une expression. Si vous souhaitez modifier les champs calculés existants, vous pouvez y parvenir en sélectionnant simplement le champ sous « Membres calculés ».",
      QuarterYear: "Trimestre de l'année",
      fieldTitle: "Nom de domaine",
      drillError:
        "Impossible d'afficher les éléments bruts des champs calculés.",
      caption: "Légende de champ",
      copy: "Copie",
      defaultReport: "Rapport défaut",
      customFormatString: "Format personnalisé",
      invalidFormat: "Format invalide.",
      group: "Grouper",
      unGroup: "Dissocier",
      invalidSelection: "Impossible de grouper cette sélection.",
      groupName: "Entrez la légende à afficher dans l'en-tête",
      captionName: "Entrez la légende pour le champ de groupe",
      selectedItems: "Éléments sélectionnés",
      groupFieldCaption: "Légende de champ",
      groupTitle: "Nom de groupe",
      startAt: "À partir de",
      endAt: "Se terminant à",
      groupBy: "Grouper par",
      selectGroup: "Sélectionnez des groupes",
      numberFormatString: "Exemple: C, P, 0000%, ### 0. ## 0 #, etc.",
      stackingcolumn: "Colonne empilée",
      stackingbar: "Barre empilée",
      stackingarea: "Zone empilée",
      stepline: "Ligne à étape",
      steparea: "Zone de l'étape",
      splinearea: "Zone de point",
      spline: "Spline",
      stackingcolumn100: "Colonne 100% empilée",
      stackingbar100: "Barre 100% empilée",
      stackingarea100: "Zone 100% empilée",
      bubble: "Bulle",
      pareto: "Pareto",
      radar: "Radar",
      chartTypeSettings: "Paramètres de type de graphique",
      multipleAxes: "Axe Multiples ",
      sortAscending: "Trier par ordre croissant",
      sortDescending: "Trier par ordre décroissant",
      sortNone: "Trier par ordre des données",
      clearCalculatedField: "Effacer les informations des champs modifiés",
      editCalculatedField: "Modifier le champ calculé",
      ChartType: "Type de graphique",
      yes: "Oui",
      no: "Non",
      numberFormatMenu: "Formatage des nombres ...",
      conditionalFormattingMenu: "Mise en forme conditionnelle...",
      removeCalculatedField:
        "Voulez-vous vraiment supprimer ce champ calculé ?",
      replaceConfirmBefore: "Un rapport nommé",
      replaceConfirmAfter: " existe déjà. Voulez-vous le remplacer ?",
      pie: "Tarte",
      funnel: "Entonnoir",
      doughnut: "Donut",
      pyramid: "Pyramide",
      showLegend: "Afficher la légende",
      exit: "Sortie",
      invalidJSON: "Données JSON non valides",
      invalidCSV: "Données CSV non valides",
      stacked: "Empilé",
      single: "Seul",
      multipleAxisMode: "Mode à axes multiples",
      grandTotalPosition: "Position des totaux généraux",
      top: "Haut",
      bottom: "Bas",
      None: "Aucun",
      stackingline: "Ligne empilée",
      stackingline100: "100% Ligne empilée",
      rowPage: "Téléavertisseur de ligne",
      rowPerPage: "Lignes par page",
      columnPage: "Téléavertisseur de colonne",
      columnPerPage: "Colonnes par page",
      goToFirstPage: "Aller à la première page",
      goToPreviousPage: "Aller à la page précédente",
      goToNextPage: "Aller à la page suivante",
      goToLastPage: "Aller à la dernière page",
      combined: "Combiné",
      subTotalPosition: "Position des sous-totaux",
      auto: "Auto",
      loading: "Chargement...",
      add: "Ajouter",
    },
    pivotfieldlist: {
      staticFieldList: "Liste des champs de pivot",
      fieldList: "Liste de champ",
      dropFilterPrompt: "Déposer le filtre ici",
      dropColPrompt: "Déposer la colonne ici",
      dropRowPrompt: "Déposer la ligne ici",
      dropValPrompt: "Déposer la valeur ici",
      addPrompt: "Ajouter un champ ici",
      adaptiveFieldHeader: "Choisissez un champ",
      centerHeader: "Faites glisser les champs entre les axes ci-dessous :",
      add: "Ajouter",
      drag: "Glisser",
      filter: "Filtre",
      filtered: "Filtré",
      sort: "Trier",
      remove: "Retirer",
      filters: "Filtres",
      rows: "Lignes",
      columns: "Colonnes",
      values: "Valeurs",
      CalculatedField: "Champ calculé",
      createCalculatedField: "Créer un champ calculé",
      fieldName: "Entrez le nom du champ",
      error: "Erreur",
      invalidFormula: "Formule non valide.",
      dropText: "Exemple: ('Sum (Order_Count)' + 'Sum (In_Stock)' ') * 250",
      dropTextMobile: "Ajoutez des champs et modifiez la formule ici.",
      dropAction:
        "Le champ calculé ne peut être placé dans aucune autre région à l'exception de l'axe des valeurs.",
      search: "Chercher",
      close: "Fermer",
      cancel: "Annuler",
      delete: "Supprimer",
      alert: "Alerte",
      warning: "Avertissement",
      ok: "Valider",
      allFields: "Tous les champs",
      formula: "Formule",
      fieldExist:
        "Un champ existe déjà sous ce nom. Veuillez saisir un nom différent.",
      confirmText:
        "Un champ de calcul existe déjà sous ce nom. Voulez-vous le remplacer ?",
      noMatches: "Pas de correspondance",
      format: "Résume les valeurs par",
      edit: "Éditer",
      clear: "Effacer",
      formulaField: "Glissez et déposez les champs dans la formule",
      dragField: "Faites glisser le champ vers la formule",
      clearFilter: "Effacer les filtres",
      by: "par",
      enterValue: "Entrez une valeur",
      chooseDate: "Entrez la date",
      all: "Tout",
      multipleItems: "Articles multiples",
      Equals: "Équivaut à",
      DoesNotEquals: "N'est pas égal",
      BeginWith: "Commence par",
      DoesNotBeginWith: "Ne commence pas par",
      EndsWith: "Se termine par",
      DoesNotEndsWith: "Ne se termine pas par",
      Contains: "Contient",
      DoesNotContains: "Ne contient pas",
      GreaterThan: "Plus grand que",
      GreaterThanOrEqualTo: "Plus grand ou égal à",
      LessThan: "Moins que",
      LessThanOrEqualTo: "Inférieur ou égal à",
      Between: "Entre",
      NotBetween: "Pas entre",
      Before: "Avant",
      BeforeOrEqualTo: "Avant ou égal à",
      After: "Après",
      AfterOrEqualTo: "Après ou égal à",
      member: "Membre",
      label: "Étiquette",
      date: "Date",
      value: "Valeur",
      labelTextContent: "Afficher les éléments pour lesquels l'étiquette",
      dateTextContent: "Afficher les éléments pour lesquels la date",
      valueTextContent: "Afficher les articles pour lesquels",
      And: "et",
      Sum: "Somme",
      Count: "Compter",
      DistinctCount: "Nombre distinct",
      Product: "Produit",
      Avg: "Moyenne",
      Min: "Min",
      Max: "Max",
      Index: "Indice",
      SampleStDev: "Exemple StDev",
      PopulationStDev: "La population de StDev",
      SampleVar: "Échantillon Var",
      PopulationVar: "Population Var",
      RunningTotals: "Totaux en cours d'exécution",
      DifferenceFrom: "Différence de",
      PercentageOfDifferenceFrom: "% de différence par rapport à",
      PercentageOfGrandTotal: "% du grand total",
      PercentageOfColumnTotal: "% du total de la colonne",
      PercentageOfRowTotal: "% du total des lignes",
      PercentageOfParentTotal: "% du total des parents",
      PercentageOfParentColumnTotal: "% du total de la colonne parent",
      PercentageOfParentRowTotal: "% du total de la ligne parent",
      Years: "Ans",
      Quarters: "Quartiers",
      Months: "Mois",
      Days: "Jours",
      Hours: "Heures",
      Minutes: "Minutes",
      Seconds: "Secondes",
      apply: "APPLIQUER",
      valueFieldSettings: "Paramètres de champ de valeur",
      sourceName: "Nom de champ :",
      sourceCaption: "Légende de champ :",
      summarizeValuesBy: "Résumer les valeurs par :",
      baseField: "Champ de base:",
      baseItem: "Élément de base:",
      example: "par exemple:",
      editorDataLimitMsg:
        " Plus d'articles. Recherchez pour affiner davantage.",
      deferLayoutUpdate: "Différer la mise à jour de la mise en page",
      null: "nul",
      undefined: "indéfini",
      groupOutOfRange: "Hors de portée",
      fieldDropErrorAction:
        "Le champ que vous déplacez ne peut pas être placé dans cette zone du rapport",
      MoreOption: "Plus...",
      memberType: "Type de champ",
      selectedHierarchy: "Hiérarchie parente",
      formatString: "Format de chaîne",
      expressionField: "Expression",
      olapDropText:
        "Exemple: [Mesures]. [Quantité de commande] + ([Mesures]. [Quantité de commande] * 0,10)",
      customFormat: "Entrez une chaîne de format personnalisé",
      Measure: "Mesure",
      Dimension: "Dimension",
      Standard: "Standard",
      Currency: "Devise",
      Percent: "Pour cent",
      Custom: "Personnalisé",
      blank: "(Vide)",
      fieldTooltip:
        "Faites glisser et déposez les champs pour créer une expression. Si vous souhaitez modifier les champs calculés existants, vous pouvez y parvenir en sélectionnant simplement le champ sous « Membres calculés ».",
      fieldTitle: "Nom de domaine",
      QuarterYear: "Trimestre de l'année",
      caption: "Légende de champ",
      copy: "Copie",
      group: "Grouper",
      numberFormatString: "Exemple: C, P, 0000%, ### 0. ## 0 #, etc.",
      sortAscending: "Trier par ordre croissant",
      sortDescending: "Trier par ordre décroissant",
      sortNone: "Trier par ordre des données",
      clearCalculatedField: "Effacer les informations des champs modifiés",
      editCalculatedField: "Modifier le champ calculé",
      selectGroup: "Sélectionnez des groupes",
      of: "de",
      removeCalculatedField:
        "Voulez-vous vraiment supprimer ce champ calculé ?",
      yes: "Oui",
      no: "Non",
      None: "Aucun",
      qtr: "trimestre",
      grandTotal: "Grand Total",
    },
    pdfviewer: {
      PdfViewer: "Visionneuse PDF",
      Cancel: "Annuler",
      "Download file": "Télécharger le fichier",
      Download: "Télécharger",
      "Enter Password":
        "Ce document est protégé par mot de passe. Veuillez entrer un mot de passe.",
      "File Corrupted": "Fichier corrompu",
      "File Corrupted Content":
        "Le fichier est corrompu et ne peut pas être ouvert.",
      "Fit Page": "Ajuster la page",
      "Fit Width": "Ajuster la largeur",
      Automatic: "Automatique",
      "Go To First Page": "Afficher la première page",
      "Invalid Password": "Mot de passe incorrect. Veuillez réessayer.",
      "Next Page": "Afficher la page suivante",
      OK: "OK",
      Open: "Ouvrir le fichier",
      "Page Number": "Numéro de page actuel",
      "Previous Page": "Afficher la page précédente",
      "Go To Last Page": "Afficher la dernière page",
      Zoom: "Zoom",
      "Zoom In": "Agrandir",
      "Zoom Out": "Dézoomer",
      "Page Thumbnails": "Vignettes de page",
      Bookmarks: "Signets",
      Print: "Imprimer le fichier",
      "Password Protected": "Mot de passe requis",
      Copy: "Copier",
      "Text Selection": "Outil de sélection de texte",
      Panning: "Mode panoramique",
      "Text Search": "Rechercher du texte",
      "Find in document": "Rechercher dans le document",
      "Match case": "Cas de correspondance",
      Apply: "Appliquer",
      GoToPage: "Aller à la page",
      "No matches":
        "La visionneuse a terminé la recherche du document. Aucune autre correspondance n'a été trouvée",
      "No Text Found": "Aucun texte trouvé",
      Undo: "Défaire",
      Redo: "Refaire",
      Annotation: "Ajouter ou modifier des annotations",
      Highlight: "Texte Surligner",
      Underline: "Souligner le texte",
      Strikethrough: "Texte barré",
      Delete: "Supprimer l'annotation",
      Opacity: "Opacité",
      "Color edit": "Changer de couleur",
      "Opacity edit": "Changer l'opacité",
      "Highlight context": "Surligner",
      "Underline context": "Souligner",
      "Strikethrough context": "Barrer",
      "Server error":
        "Le service Web n'écoute pas. PDF Viewer dépend du service Web pour toutes ses fonctionnalités. Veuillez démarrer le service Web pour continuer.",
      "Open text": "Ouvert",
      "First text": "Première Page",
      "Previous text": "Page Précédente",
      "Next text": "Page Suivante",
      "Last text": "Dernière Page",
      "Zoom in text": "Zoom Avant",
      "Zoom out text": "Zoom Arrière",
      "Selection text": "Sélection",
      "Pan text": "La poêle",
      "Print text": "Impression",
      "Search text": "Chercher",
      "Annotation Edit text": "Modifier l'annotation",
      "Line Thickness": "Épaisseur de ligne",
      "Line Properties": "Propriétés de ligne",
      "Start Arrow": "Flèche de départ",
      "End Arrow": "Flèche de fin",
      "Line Style": "Style de ligne",
      "Fill Color": "La couleur de remplissage",
      "Line Color": "Couleur de la ligne",
      None: "Aucun",
      "Open Arrow": "Ouvert",
      "Closed Arrow": "Fermé",
      "Round Arrow": "Rond",
      "Square Arrow": "Carré",
      "Diamond Arrow": "diamant",
      Butt: "Bout",
      Cut: "Couper",
      Paste: "Coller",
      "Delete Context": "Supprimer",
      Properties: "Propriétés",
      "Add Stamp": "Ajouter un tampon",
      "Add Shapes": "Ajouter des formes",
      "Stroke edit": "Changer la couleur du trait",
      "Change thickness": "Modifier l'épaisseur de la bordure",
      "Add line": "Ajouter une ligne",
      "Add arrow": "Ajouter une flèche",
      "Add rectangle": "Ajouter un rectangle",
      "Add circle": "Ajouter un cercle",
      "Add polygon": "Ajouter un polygone",
      "Add Comments": "Ajouter des commentaires",
      Comments: "Commentaires",
      "No Comments Yet": "Aucun commentaire pour l'instant",
      Accepted: "Accepté",
      Completed: "Terminé",
      Cancelled: "Annulé",
      Rejected: "Rejeté",
      "Leader Length": "Longueur de ligne de repère",
      "Scale Ratio": "Rapport d'échelle",
      Calibrate: "Étalonner",
      "Calibrate Distance": "Calibrer la distance",
      "Calibrate Perimeter": "Calibrer le périmètre",
      "Calibrate Area": "Étalonner la zone",
      "Calibrate Radius": "Calibrer le rayon",
      "Calibrate Volume": "Calibrer le volume",
      highlight: "Souligner",
      underline: "Souligner",
      strikethrough: "Barré",
      "Seach text": "Chercher",
      FormDesigner: "Ajouter et modifier des champs de formulaire",
      "Client error":
        "Une erreur côté client est détectée. Veuillez vérifier les en-têtes personnalisés fournis dans la propriété AjaxRequestSettings et les méthodes d'action Web dans la propriété ServerActionSettings.",
      "FormDesigner Edit text": "Ajouter et modifier des champs de formulaire",
      SubmitForm: "Soumettre le formulaire",
      Depth: "Profondeur",
      Closed: "Fermé",
      Round: "Tour",
      Square: "Carré",
      Diamond: "diamant",
      Edit: "Éditer",
      Comment: "Commenter",
      "Comment Panel": "Panneau de commentaires",
      "Set Status": "Définir le statut",
      Post: "Poster",
      Page: "Page",
      "Add a comment": "Ajouter un commentaire",
      "Add a reply": "Ajouter une réponse",
      "Import Annotations":
        "Importer des annotations à partir d'un fichier JSON",
      "Export Annotations": "Exporter l'annotation vers un fichier JSON",
      "Export XFDF": "Exporter l'annotation vers un fichier XFDF",
      "Import XFDF": "Importer des annotations à partir d'un fichier XFDF",
      Add: "Ajouter",
      Clear: "Dégager",
      Bold: "Audacieux",
      Italic: "Italique",
      Strikethroughs: "Barré",
      Underlines: "Souligner",
      Superscript: "Exposant",
      Subscript: "Indice",
      "Align left": "Alignez à gauche",
      "Align right": "Aligner à droite",
      Center: "Centre",
      Justify: "Justifier",
      "Font color": "Couleur de la police",
      "Text Align": "Aligner le texte",
      "Text Properties": "Le style de police",
      SignatureFieldDialogHeaderText: "Ajouter une signature",
      HandwrittenSignatureDialogHeaderText: "Ajouter une signature",
      InitialFieldDialogHeaderText: "Ajouter une initiale",
      HandwrittenInitialDialogHeaderText: "Ajouter une initiale",
      "Draw Ink": "Dessiner de l'encre",
      Create: "Créer",
      "Font family": "Famille de polices",
      "Font size": "Taille de police",
      "Free Text": "Texte libre",
      "Import Failed":
        "Type de fichier JSON ou nom de fichier non valide; veuillez sélectionner un fichier JSON valide",
      "File not found":
        "Le fichier JSON importé est introuvable à l'emplacement souhaité",
      "Export Failed":
        "L'action d'exportation des annotations a échoué; veuillez vous assurer que les annotations sont ajoutées correctement",
      of: "de ",
      Dynamic: "Dynamique",
      "Standard Business": "Entreprise standard",
      "Sign Here": "Signez ici",
      "Custom Stamp": "Tampon personnalisé",
      "Enter Signature as Name": "Entrez votre nom",
      "Draw-hand Signature": "DESSINER",
      "Type Signature": "TAPER",
      "Upload Signature": "TÉLÉCHARGER",
      "Browse Signature Image": "FEUILLETER",
      "Save Signature": "Enregistrer la signature",
      "Save Initial": "Enregistrer l'initiale",
      Textbox: "Zone de texte",
      Password: "Mot de passe",
      "Check Box": "Case à cocher",
      "Radio Button": "Bouton radio",
      Dropdown: "Menu déroulant",
      "List Box": "Zone de liste",
      Signature: "Signature",
      "Delete FormField": "Supprimer le champ du formulaire",
      "Textbox Properties": "Propriétés de la zone de texte",
      Name: "Nom",
      Tooltip: "Info-bulle",
      Value: "Évaluer",
      "Form Field Visibility": "Visibilité des champs de formulaire",
      "Read Only": "Lecture seulement",
      Required: "Obligatoire",
      Checked: "Vérifié",
      "Show Printing": "Afficher l'impression",
      Formatting: "Format",
      Fill: "Remplir",
      Border: "Frontière",
      "Border Color": "Couleur de la bordure",
      Thickness: "Épaisseur",
      "Max Length": "Longueur maximale",
      "List Item": "Nom de l'article",
      "Export Value": "Valeur de l'article",
      "Dropdown Item List": "Liste déroulante des éléments",
      "List Box Item List": "Liste des éléments de la zone de liste",
      General: "GÉNÉRAL",
      Appearance: "APPARENCE",
      Options: "OPTIONS",
      "Delete Item": "Effacer",
      Up: "En haut",
      Down: "Vers le bas",
      Multiline: "Multiligne",
      Revised: "modifié",
      Reviewed: "Révisé",
      Received: "Reçu",
      Confidential: "Confidentiel",
      Approved: "Approuvé",
      "Not Approved": "Non approuvé",
      Witness: "Témoin",
      "Initial Here": "Vos initiales ici",
      Draft: "Brouillon",
      Final: "Final",
      "For Public Release": "Pour diffusion publique",
      "Not For Public Release": "Pas pour diffusion publique",
      "For Comment": "Pour un commentaire",
      Void: "Annuler",
      "Preliminary Results": "Résultats préliminaires",
      "Information Only": "Information seulement",
      in: "dans",
      m: "m",
      ft_in: "ft_in",
      ft: "pi",
      p: "p",
      cm: "cm",
      mm: "millimètre",
      pt: "pt",
      cu: "cu",
      sq: "m²",
      Initial: "Initial",
    },
    diagram: {
      Copy: "Copier",
      Cut: "Couper",
      Paste: "Coller",
      Undo: "Défaire",
      Redo: "Refaire",
      SelectAll: "Tout sélectionner",
      Grouping: "Regroupement",
      Group: "Grouper",
      UnGroup: "Dissocier",
      Order: "Commande",
      BringToFront: "Mettre au premier plan",
      MoveForward: "Avancer",
      SendToBack: "Envoyer à l'arrière",
      SendBackward: "Envoyer vers l'arrière",
      group: "Grouper",
    },
    "inplace-editor": {
      save: "Sauvegarder",
      cancel: "Annuler",
      loadingText: "Chargement...",
      editIcon: "Cliquez pour modifier",
      editAreaClick: "Cliquez pour modifier",
      editAreaDoubleClick: "Double-cliquez pour modifier",
    },
    drawing: {},
    "drop-down-base": {
      noRecordsTemplate: "Aucun enregistrement trouvé",
      actionFailureTemplate: "La demande a échoué",
    },
    chart: {
      Zoom: "Zoom",
      ZoomIn: "Agrandir",
      ZoomOut: "Dézoomer",
      Reset: "Réinitialiser",
      Pan: "La poêle",
      ResetZoom: "Réinitialiser le zoom",
    },
    maps: {
      Zoom: "Zoom",
      ZoomIn: "Agrandir",
      ZoomOut: "Dézoomer",
      Reset: "Réinitialiser",
      Pan: "Déplacer",
      ResetZoom: "Réinitialiser le zoom",
      ImageNotFound: "Image non trouvée",
    },
    "drop-down-tree": {
      noRecordsTemplate: "Aucun enregistrement trouvé",
      actionFailureTemplate: "Demande échoué",
      overflowCountTemplate: "+ ${count} de plus ..",
      totalCountTemplate: "${count} sélectionnés",
    },
    documenteditor: {
      Table: "Tableau",
      Row: "Ligne",
      Cell: "Cellule",
      Ok: "OK",
      Apply: "Appliquer",
      Cancel: "Annuler",
      Size: "Taille",
      "Preferred Width": "Largeur préférée",
      Points: "Points",
      Percent: "Pour cent",
      "Measure in": "Mesurer en",
      Alignment: "Alignement",
      Left: "Gauche",
      Center: "Centre",
      Right: "Droite",
      Decimal: "Décimal",
      Bar: "Barre",
      Leader: "gestionnaires",
      Tab: "Factures impayées",
      BookMarkList: "Liste de signets dans le document",
      TabMarkList: "Liste des tabulations dans le paragraphe",
      "Tab stop position": "Position de la tabulation",
      "Default tab stops": "Tabulations par défaut",
      "Tab stops to be cleared": "Tabulations à effacer",
      Tabs: "Onglets",
      Set: "Configurer",
      Clear: "Clair",
      "Clear All": "Tout effacer",
      Justify: "Justifier",
      "Indent from left": "Retrait de gauche",
      "Borders and Shading": "Bordures et ombrage",
      Options: "Les options",
      "Specify height": "Précisez la hauteur",
      "At least": "Au moins",
      Exactly: "Exactement",
      "Row height is": "La hauteur de ligne est",
      "Allow row to break across pages":
        "Autoriser la ligne à traverser les pages",
      "Repeat as header row at the top of each page":
        "Répéter comme ligne d'en-tête en haut de chaque page",
      "Vertical alignment": "Alignement vertical",
      Top: "Haut",
      Bottom: "Bas",
      "Default cell margins": "Marges de cellule par défaut",
      "Default cell spacing": "Espacement des cellules par défaut",
      "Allow spacing between cells":
        "Autoriser l'espacement entre les cellules",
      "Cell margins": "Marges des cellules",
      "Same as the whole table": "Identique à toute la table",
      Borders: "Les frontières",
      None: "Aucun",
      Style: "Style",
      Width: "Largeur",
      Height: "la taille",
      Letter: "Lettre",
      Tabloid: "Tabloïde",
      Legal: "Légal",
      Statement: "Déclaration",
      Executive: "Exécutif",
      A3: "A3",
      A4: "A4",
      A5: "A5",
      B4: "B4",
      B5: "B5",
      "Custom Size": "Format personnalisé",
      "Different odd and even": "Différent impair et pair",
      "Different first page": "Première page différente",
      "From edge": "Du bord",
      Header: "Entête",
      Footer: "Bas de page",
      "First Page Header": "En-tête de la première page",
      "First Page Footer": "Pied de page de la première page",
      "Even Page Header": "En-tête de page pair",
      "Even Page Footer": "Pied de page pair",
      "Odd Page Header": "En-tête de page impaire",
      "Odd Page Footer": "Pied de page impair",
      "Same as Previous": "Identique au précédent",
      Section: "Section",
      Margin: "Marges",
      Paper: "Papier",
      Layout: "Disposition",
      Orientation: "Orientation",
      Landscape: "Paysage",
      Portrait: "Portrait",
      "Show page numbers": "Afficher les numéros de page",
      "Right align page numbers": "Aligner à droite les numéros de page",
      Nothing: "Rien",
      "Tab leader": "Repère de tabulation",
      "Show levels": "Afficher les niveaux",
      "Use hyperlinks instead of page numbers":
        "Utilisez des hyperliens au lieu des numéros de page",
      "Build table of contents from":
        "Créer une table des matières à partir de",
      Styles: "modes",
      "Available styles": "Styles disponibles",
      "TOC level": "Niveau COT",
      Heading: "Titre",
      "Heading 1": "Titre 1",
      "Heading 2": "Titre 2",
      "Heading 3": "Titre 3",
      "Heading 4": "Titre 4",
      "Heading 5": "Titre 5",
      "Heading 6": "Titre 6",
      "List Paragraph": "Paragraphe de liste",
      Normal: "Normale",
      "Outline levels": "Niveaux de contour",
      "Table entry fields": "Champs de saisie de table",
      Modify: "Modifier",
      Color: "Couleur",
      Setting: "Réglage",
      Box: "Boîte",
      All: "Tout",
      Custom: "Personnalisé",
      Preview: "Aperçu",
      Shading: "Ombres",
      Fill: "Remplir",
      "Apply To": "Postuler à",
      "Table Properties": "Propriétés du tableau",
      "Cell Options": "Options de cellule",
      "Table Options": "Options de table",
      "Insert Table": "Insérer un tableau",
      "Number of columns": "Le nombre de colonnes",
      "Number of rows": "Nombre de rangées",
      "Text to display": "Texte à afficher",
      "ScreenTip text": "Texte de l'info-bulle",
      Address: "Adresse",
      "Insert Hyperlink": "Insérer un lien hypertexte",
      "Edit Hyperlink": "Modifier l'hyperlien",
      Insert: "Insérer",
      General: "Général",
      "The number must be between": "Le nombre doit être compris entre 1 et 9",
      "The Invalid number": "Ce n'est pas un numéro valide",
      Indentation: "Échancrure",
      "Before text": "Avant le texte",
      Special: "Spécial",
      "First line": "Première ligne",
      Hanging: "Pendaison",
      "After text": "Après le texte",
      By: "Par",
      Before: "Avant",
      "Line Spacing": "Interligne",
      After: "Après",
      At: "À",
      Multiple: "Plusieurs",
      Spacing: "Espacement",
      "Define new Multilevel list":
        "Définir une nouvelle liste à plusieurs niveaux",
      "List level": "Niveau liste",
      "Choose level to modify": "Choisissez le niveau à modifier",
      Level: "Niveau",
      "Number format": "Format de nombre",
      "Number style for this level": "Style de nombre pour ce niveau",
      "Enter formatting for number": "Entrez la mise en forme du nombre",
      "Start at": "Commencer à",
      "Restart list after": "Redémarrez la liste après",
      Position: "Position",
      "Text indent at": "Retrait du texte à",
      "Aligned at": "Aligné à",
      "Follow number with": "Suivez le numéro avec",
      "Tab character": "Caractère de tabulation",
      Space: "Espace",
      Arabic: "arabe",
      UpRoman: "UpRoman",
      LowRoman: "BasRomain",
      UpLetter: "UpLettre",
      LowLetter: "LowLetter",
      Number: "Nombre",
      "Leading zero": "Zéro en tête",
      Bullet: "Balle",
      Ordinal: "Ordinal",
      "Ordinal Text": "Texte ordinal",
      "For East": "Pour l'Est",
      "No Restart": "Pas de redémarrage",
      Font: "Police de caractère",
      "Font style": "Le style de police",
      "Underline style": "Souligner le style",
      "Font color": "Couleur de la police",
      Effects: "Effets",
      Strikethrough: "Barré",
      Superscript: "Exposant",
      Subscript: "Indice",
      "Double strikethrough": "Barré double",
      Regular: "Ordinaire",
      Bold: "Audacieux",
      Italic: "Italique",
      Cut: "Couper",
      Copy: "Copier",
      Paste: "Coller",
      Hyperlink: "Hyperlien",
      "Open Hyperlink": "Ouvrir l'hyperlien",
      "Copy Hyperlink": "Copier l'hyperlien",
      "Remove Hyperlink": "Supprimer l'hyperlien",
      Paragraph: "Paragraphe",
      "Linked Style": "Lié (paragraphe et caractère)",
      Character: "Personnage",
      "Merge Cells": "Fusionner des cellules",
      "Insert Above": "Insérer au-dessus",
      "Insert Below": "Insérer ci-dessous",
      "Insert Left": "Insérer à gauche",
      "Insert Right": "Insérer à droite",
      Delete: "Supprimer",
      "Delete Table": "Supprimer le tableau",
      "Delete Row": "Supprimer la ligne",
      "Delete Column": "Supprimer la colonne",
      "File Name": "Nom de fichier",
      "Format Type": "Type de format",
      Save: "sauvegarder",
      Navigation: "La navigation",
      Results: "Résultats",
      Replace: "Remplacer",
      "Replace All": "Remplace tout",
      "We replaced all": "Nous avons remplacé tous",
      Find: "Trouver",
      "No matches": "Aucune correspondance",
      "All Done": "Terminé",
      Result: "Résultat",
      of: "de",
      instances: "instances",
      with: "avec",
      "Click to follow link": "Cliquez pour suivre le lien",
      "Continue Numbering": "Continuer la numérotation",
      "Bookmark name": "Nom du signet",
      Close: "Fermer",
      "Restart At": "Redémarrer à",
      Properties: "Propriétés",
      Name: "Nom",
      "Style type": "Type de style",
      "Style based on": "Style basé sur",
      "Style for following paragraph": "Style pour le paragraphe suivant",
      Formatting: "Mise en page",
      "Numbering and Bullets": "Numérotation et puces",
      Numbering: "Numérotage",
      "Update Field": "Champ de mise à jour",
      "Edit Field": "Modifier le champ",
      Bookmark: "Signet",
      "Page Setup": "Mise en page",
      "No bookmarks found": "Aucun signet trouvé",
      "Number format tooltip information":
        "Format numérique à un niveau: </br> [PREFIX]% [LEVELNUMBER] [SUFFIX] </br> Par exemple, 'Chapitre% 1.' affichera la numérotation comme </br> Chapitre 1. Article </br> Chapitre 2. Article </br>… </br> Chapitre N. Article </br> </br> Format numérique à plusieurs niveaux: </br> [ PREFIX]% [LEVELNUMBER] [SUFFIX] + [PREFIX]% [LEVELNUMBER] [SUFFIX] </br> Par exemple, '% 1.% 2.' affichera la numérotation comme </br> 1.1. Article </br> 1.2. Article </br>… </br> 1.N. Article",
      Format: "Format",
      "Create New Style": "Créer un nouveau style",
      "Modify Style": "Modifier le style",
      New: "Nouveau",
      Bullets: "Balles",
      "Use bookmarks": "Utiliser des signets",
      "Table of Contents": "Table des matières",
      AutoFit: "Ajustement automatique",
      "AutoFit to Contents": "Ajustement automatique au contenu",
      "AutoFit to Window": "Ajustement automatique à la fenêtre",
      "Fixed Column Width": "Largeur de colonne fixe",
      Reset: "Réinitialiser",
      "Match case": "Cas de correspondance",
      "Whole words": "Mots entiers",
      Add: "Ajouter",
      "Go To": "Aller à",
      "Search for": "Rechercher",
      "Replace with": "Remplacer par",
      "TOC 1": "Table des matières 1",
      "TOC 2": "Table des matières 2",
      "TOC 3": "Table des matières 3",
      "TOC 4": "Table des matières 4",
      "TOC 5": "Table des matières 5",
      "TOC 6": "Table des matières 6",
      "TOC 7": "Table des matières 7",
      "TOC 8": "Table des matières 8",
      "TOC 9": "Table des matières 9",
      "Right-to-left": "De droite à gauche",
      "Left-to-right": "De gauche à droite",
      Direction: "Direction",
      "Table direction": "Direction de la table",
      "Indent from right": "Retrait à droite",
      "Contextual Spacing":
        "N'ajoutez pas d'espace entre les paragraphes des mêmes styles",
      "Password Mismatch": "Le mot de passe ne correspond pas",
      "Restrict Editing": "Restreindre l'édition",
      "Formatting restrictions": "Restrictions de formatage",
      "Allow formatting": "Autoriser la mise en forme",
      "Editing restrictions": "Modification des restrictions",
      "Read only": "Lecture seulement",
      "Exceptions Optional": "Exceptions (facultatif)",
      "Select Part Of Document And User":
        "Sélectionnez des parties du document et choisissez les utilisateurs autorisés à les modifier librement.",
      Everyone: "Toutes les personnes",
      "More users": "Plus d'utilisateurs",
      "Add Users": "Ajouter des utilisateurs",
      "Enforcing Protection": "Oui, commencez à appliquer la protection",
      "Start Enforcing Protection": "Commencer à appliquer la protection",
      "Enter User": "Entrez l'utilisateur",
      Users: "Utilisateurs",
      "Enter new password": "Entrez un nouveau mot de passe",
      "Reenter new password to confirm":
        "Entrez à nouveau le nouveau mot de passe pour confirmer",
      "Your permissions": "Vos autorisations",
      "Protected Document":
        "Ce document est protégé contre toute modification involontaire. Vous pouvez le modifier dans cette région.",
      FormFieldsOnly:
        "Vous ne pouvez remplir des formulaires que dans cette région.",
      CommentsOnly:
        "Vous ne pouvez insérer des commentaires que dans cette région.",
      ReadOnlyProtection: "Vous pouvez éditer dans cette région.",
      "Stop Protection": "Arrêter la protection",
      Password: "Mot de passe",
      "Spelling Editor": "Éditeur d'orthographe",
      Spelling: "Orthographe",
      "Spell Check": "Vérification orthographique",
      "Underline errors": "Souligner les erreurs",
      Ignore: "Ignorer",
      "Ignore All": "Ignorer tout",
      "Add to Dictionary": "Ajouter au dictionnaire",
      Change: "Changement",
      "Change All": "Change tout",
      Suggestions: "Suggestions",
      "The password is incorrect": "Le mot de passe est incorrect",
      "Error in establishing connection with web server":
        "Erreur lors de l'établissement de la connexion avec le serveur Web",
      "Highlight the regions I can edit":
        "Mettez en surbrillance les régions que je peux modifier",
      "Show All Regions I Can Edit":
        "Afficher toutes les régions que je peux modifier",
      "Find Next Region I Can Edit":
        "Rechercher la prochaine région que je peux modifier",
      "Keep source formatting": "Conserver le formatage source",
      "Match destination formatting":
        "Faire correspondre la mise en forme de la destination",
      "Text only": "Texte seulement",
      Comments: "commentaires",
      "Type your comment": "Tapez votre commentaire",
      Post: "Publier",
      Reply: "Répondre",
      "New Comment": "Nouveau commentaire",
      Edit: "Éditer",
      Resolve: "Résoudre",
      Reopen: "Rouvrir",
      "No comments in this document": "Aucun commentaire dans ce document",
      more: "plus",
      "Type your comment here": "Tapez votre commentaire ici",
      "Next Comment": "Commentaire suivant",
      "Previous Comment": "Commentaire précédent",
      "Un-posted comments": "Commentaires non publiés",
      "Discard Comment":
        "Ajout de commentaires non publiés. Si vous continuez, ce commentaire sera ignoré.",
      Discard: "Jeter",
      "No Headings": "Jeter",
      "Add Headings":
        "Ce document n'a pas de titres. Veuillez ajouter des titres et réessayer.",
      "More Options": "Plus d'options",
      "Click to see this comment": "Cliquez pour voir ce commentaire",
      "Drop Down Form Field": "Champ de formulaire déroulant",
      "Drop-down items": "Articles déroulants",
      "Items in drop-down list": "Éléments dans la liste déroulante",
      ADD: "AJOUTER",
      REMOVE: "RETIRER",
      "Field settings": "Réglages sur place",
      Tooltip: "Info-bulle",
      "Drop-down enabled": "Liste déroulante activée",
      "Check Box Form Field": "Champ de formulaire de case à cocher",
      "Check box size": "Cochez la taille",
      Auto: "Auto",
      "Default value": "Valeur par défaut",
      "Not checked": "Non vérifié",
      Checked: "Vérifié",
      "Check box enabled": "Case à cocher activée",
      "Text Form Field": "Champ de formulaire texte",
      Type: "Taper",
      "Default text": "Texte par défaut",
      "Maximum length": "Longueur maximale",
      "Text format": "Format texte",
      "Fill-in enabled": "Remplissage activé",
      "Default number": "Numéro par défaut",
      "Default date": "Date par défaut",
      "Date format": "Format de date",
      "Merge Track":
        "Cette action ne sera pas marquée comme modification. Voulez-vous continuer ?",
      UnTrack: "Ne peut pas être suivi",
      Accept: "Accepter",
      Reject: "Rejeter",
      "Previous Changes": "Modifications précédentes",
      "Next Changes": "Changements suivants",
      Inserted: "Inséré",
      Deleted: "Supprimé",
      "Move From": "depuis",
      "Move To": "déplacé",
      Changes: "Changements",
      "Accept all": "Accepter tout",
      "Reject all": "Tout rejeter",
      "No changes": "Aucun changement",
      "Accept Changes": "Accepter les modifications",
      "Reject Changes": "Refuser les modifications",
      User: "Utilisateur",
      View: "Vue",
      Insertion: "Insertion",
      Deletion: "Effacement",
      "All caps": "Toutes en majuscules",
      "This region is locked by": "Cette région est verrouillée par",
      Lock: "Fermer à clé",
      Unlock: "Ouvrir",
      "Already locked":
        "La région sélectionnée ou une partie de la région est déjà verrouillée par un autre utilisateur",
      "1, 2, 3, ...": "1, 2, 3, ...",
      "a, b, c, ...": "a, b, c, ...",
      "A, B, C, ...": "A, B, C, ...",
      "I, II, III, ...": "I, II, III, ...",
      "i, ii, iii, ...": "je, ii, iii, ...",
      "Text Form": "Formulaire de texte",
      "Check Box": "Case à cocher",
      DropDown: "Menu déroulant",
      "Form Fields": "Champs de formulaire",
      "Fillin enabled": "Remplissage activé",
      "Multiple Comment": "Veuillez poster votre commentaire",
      InsertFootnote: "InsérerNote de bas de page",
      InsertEndnote: "InsérerEndnote",
      Footnote: "note de bas de page",
      Endnote: "Note de fin de document",
      "Notes Options": "Options de remarque",
      "Click to View/Edit Footnote":
        "Cliquez pour afficher / modifier la note de bas de page",
      "Click to View/Edit Endnote":
        "Cliquez pour afficher / modifier la note de fin",
      InsertAsRows: "Insérer en tant que nouvelles lignes",
      InsertAsColumns: "Insérer en tant que nouvelles colonnes",
      OverwriteCells: "Écraser les cellules",
      NestTable: "Table gigogne",
      "No suggestions": "Aucune suggestion",
      "More Suggestion": "Plus de suggestions",
      "Ignore Once": "Ignorer une fois",
      "Keep With Next": "Continuer avec le suivant",
      "Keep Lines Together": "Gardez les lignes ensemble",
      WidowControl: "Contrôle des veuves/orphelins",
      "Indents and Spacing": "Retraits et espacement",
      "Line and Page Breaks": "Sauts de ligne et de page",
      Pagination: "Pagination",
      Single: "Seul",
      DashSmallGap: "DashSmallGap",
      DashDot: "TiretPoint",
      Double: "Double",
      ThinThickSmallGap: "MinceÉpaisPetitEspace",
      ThickThinSmallGap: "ÉpaisMincePetitEspace",
      ThickThinMediumGap: "ÉpaisMinceMoyenÉcart",
      ThickThinLargeGap: "ÉpaisMinceGrandEspace",
      SingleWavy: "SimpleWavy",
      DoubleWavy: "DoubleOndulé",
      Inset: "Encart",
      DashLargeGap: "DashLargeGap",
      Dot: "Point",
      DashDotDot: "TiretPointPoint",
      Triple: "Tripler",
      ThinThickThinSmallGap: "MinceÉpaisMincePetitEspace",
      ThinThickThinMediumGap: "MinceÉpaisMinceMoyenÉcart",
      ThinThickThinLargeGap: "MinceÉpaisMinceLargeGap",
      DashDotStroked: "TiretPointTracé",
      Engrave3D: "Graver3D",
      Thick: "Épais",
      Outset: "Début",
      Emboss3D: "Emboss3D",
      ThinThickLargeGap: "MinceÉpaisGrandEspace",
      ThinThickMediumGap: "FinÉpaisMoyenÉcart",
      "Number of rows must be between":
        "Le nombre de lignes doit être compris entre",
      "Number of columns must be between":
        "Le nombre de colonnes doit être compris entre",
      and: "et",
      Unlimited: "Illimité",
      "Regular text": "Texte normal",
      Date: "Date",
      Uppercase: "Majuscule",
      Lowercase: "Minuscule",
      FirstCapital: "FirstCapital",
      TitleCase: "Casse du titre",
      "Filling in forms": "Remplir des formulaires",
      px: "pixels",
      "Tracked changes": "Modifications suivies",
      TrackChangesOnly:
        "Vous pouvez effectuer des modifications dans cette région, mais toutes les modifications seront suivies.",
      RemovedIgnore: "Voulez-vous supprimer les exceptions ignorées ?",
      RemovedIgnoreExceptions:
        "Si vous apportez cette modification à la protection du document, Word ignorera toutes les exceptions dans ce document.",
      Information: "Informations",
      Yes: "Oui",
      No: "Ligne",
      "Page Break": "Saut de page",
      "Column Break": "Saut de colonne",
      "Section Break Next Page": "Saut de section (page suivante)",
      "Section Break Continuous": "Saut de section (continu)",
      "Unsupported format":
        "Le format de fichier que vous avez sélectionné n'est pas pris en charge. Veuillez choisir un format valide.",
      One: "Une",
      Two: "Deux",
      Three: "Trois",
      Presets: "Préconfigurations",
      Columns: "Colonnes",
      "Split your text into two or more columns":
        "Divisez votre texte en deux colonnes ou plus",
      "Line between column": "Ligne entre colonne",
      "Width and Spacing": "Largeur et espacement",
      "Equal column width": "Largeur de colonne égale",
      Column: "Colonne",
      "Paste Content Dialog":
        "En raison de la politique de sécurité du navigateur, le collage à partir du presse-papiers du système est limité. Sinon, utilisez le raccourci clavier",
      "Paste Content CheckBox": "Ne te présente plus",
      "The top/bottom margins are too large for the page height in some sections.":
        "Les marges supérieure/inférieure sont trop grandes pour la hauteur de la page dans certaines sections.",
      "Column width cannot be less than 36 pt.":
        "La largeur de colonne ne peut pas être inférieure à 36 pt.",
      "Left and right margins.":
        "Les paramètres que vous avez choisis pour les marges gauche et droite, l'espacement des colonnes ou les retraits des paragraphes sont trop grands pour la largeur de la page dans les mêmes sections.",
      "The address of this site is 'not valid. Check the address and try again.":
        "L'adresse de ce site n'est pas valide. Vérifiez l'adresse et réessayez.",
      "Alt Text": "Texte alternatif",
      Title: "Titre",
      Description: "Description",
      "Left Indent": "Boule de communication",
      "Right Indent": "Le bon cours",
      "Hanging Indent": "Le rouleau pend",
      "First Line Indent": "Le premier est l’indentation de ligne.",
      "Left Margin": "coin gauche",
      "Right Margin": "angle droit",
      "Top Margin": "tête",
      "Bottom Margin": "pied",
      "Left Tab": "Onglet gauche",
      "Right Tab": "Onglet droit",
      "Center Tab": "Indicateur central",
      "Decimal Tab": "Couper des animaux",
      "Bar Tab": "Kumilevy",
      "Move Table Column": "Déplacer une colonne du tableau",
      external: "Supprimer le contrôle du contenu",
      "Content Control Properties": "Propriétés de contrôle du contenu",
      "Remove content control when contents are edited":
        "Supprimer le contrôle du contenu lorsque le contenu est modifié",
      "Content control cannot be deleted":
        "Le contrôle du contenu ne peut pas être supprimé",
      "Contents cannot be edited": "Le contenu ne peut pas être modifié",
      "Plain Text properties": "Propriétés de texte brut",
      "Allow carriage returns": "Autoriser les retours de transport",
      "Drop_Down List properties": "Propriétés de la liste Drop_Down",
      "Display Text": "Afficher le texte",
      Locking: "Verrouillage",
      Tag: "Étiqueter",
      Value: "Valeur",
      PictureContentControl: "PictureContentControl",
      "Upload from computer": "Télécharger d'un ordinateur",
      Picture: "Image",
      "Choose an item": "Choisir un élément",
      "Paste CheckBox Content Dialog": "Ne plus afficher",
      "The address of this site is not valid. Check the address and try again.":
        "L'adresse de ce site n'est pas valide. ",
      "Aucun en-tête": "Aucun en-tête trouvé !",
      "Left and right margins":
        "Les paramètres que vous avez choisis pour les marges gauche et droite, l'espacement des colonnes ou les retraits des paragraphes sont trop grands pour la largeur de la page dans les mêmes sections.",
      "Number of rows must be between 1 and 32767.":
        "Le nombre de lignes doit être compris entre 1 et 32 767.",
      "Number of columns must be between 1 and 63.":
        "Le nombre de colonnes doit être compris entre 1 et 63.",
      "You may format text only with certain styles":
        "Vous ne pouvez formater le texte qu'avec certains styles.",
      ok: "Valider",
    },
    documenteditorcontainer: {
      New: "Nouveau",
      Open: "Ouvrir",
      Undo: "annuler",
      Redo: "Refaire",
      Image: "Image",
      Table: "Tableau",
      Link: "Lien",
      Bookmark: "Signet",
      "Table of Contents": "Table des matières",
      "HEADING - - - - 1": "RUBRIQUE - - - - 1",
      "HEADING - - - - 2": "RUBRIQUE - - - - 2",
      "HEADING - - - - 3": "RUBRIQUE - - - - 3",
      Header: "Entête",
      Footer: "Bas de page",
      "Page Setup": "Mise en page",
      "Page Number": "Numéro de page",
      Break: "Pause",
      Find: "Trouver",
      "Local Clipboard": "Presse-papiers local",
      "Restrict Editing": "Restreindre l'édition",
      "Content Control": "Contrôle du contenu",
      "Rich Text Content Control": "Contrôle de contenu textuel riche",
      "Plain Text Content Control": "Contrôle de contenu en texte brut",
      "Picture Content Control": "Contrôle du contenu de l'image",
      "Combo Box Content Control": "Contrôle du contenu de la boîte combo",
      "Drop-Down List Content Control": "Liste déroulante Contrôle du contenu",
      "Date Picker Content Control":
        "Contrôle du contenu de la sélecteur de dattes",
      "Check Box Content Control": "Cocher le contrôle du contenu de la case",
      "Upload from computer": "Télécharger d'un ordinateur",
      "By URL": "Par URL",
      "Page Break": "Saut de page",
      "Section Break": "Saut de section",
      "Header And Footer": "En-tête et pied de page",
      Options: "Les options",
      Levels: "Niveaux",
      "Different First Page": "Première page différente",
      "Different header and footer for odd and even pages":
        "En-tête et pied de page différents pour les pages paires et impaires.",
      "Different Odd And Even Pages": "Pages paires et impaires différentes",
      "Different header and footer for first page":
        "En-tête et pied de page différents pour la première page.",
      Position: "Position",
      "Header from Top": "En-tête du haut",
      "Footer from Bottom": "Pied de page du bas",
      "Distance from top of the page to top of the header":
        "Distance du haut de la page au haut de l'en-tête.",
      "Distance from bottom of the page to bottom of the footer":
        "Distance du bas de la page au bas du pied de page.",
      "Aspect ratio": "Ratio d'aspect",
      W: "O",
      H: "H",
      Width: "Largeur",
      Height: "Hauteur",
      Text: "Texte",
      Paragraph: "Paragraphe",
      Fill: "Remplir",
      "Fill color": "La couleur de remplissage",
      "Border Style": "Style de bordure",
      "Outside borders": "Hors frontières",
      "All borders": "Toutes les frontières",
      "Inside borders": "Frontières intérieures",
      "Left border": "Bordure gauche",
      "Inside vertical border": "Bordure verticale intérieure",
      "Right border": "Bordure droite",
      "Top border": "Bordure supérieure",
      "Inside horizontal border": "Bordure horizontale intérieure",
      "Bottom border": "Bordure inférieure",
      "Border color": "Couleur de la bordure",
      "Border width": "Largeur de la bordure",
      Cell: "Cellule",
      "Merge cells": "Fusionner des cellules",
      "Insert Or Delete": "Insérer / supprimer",
      "Insert columns to the left": "Insérer des colonnes à gauche",
      "Insert columns to the right": "Insérer des colonnes à droite",
      "Insert rows above": "Insérer des lignes au-dessus",
      "Insert rows below": "Insérer des lignes ci-dessous",
      "Delete rows": "Supprimer des lignes",
      "Delete columns": "Supprimer des colonnes",
      "Cell Margin": "Marge cellulaire",
      Top: "Haut",
      Bottom: "Bas",
      Left: "Gauche",
      Right: "Droite",
      "Align Text": "Aligner le texte",
      "Align top": "Aligner le haut",
      "Align bottom": "Aligner en bas",
      "Align center": "Aligner le centre",
      "Number of heading or outline levels to be shown in table of contents":
        "Nombre de niveaux de titre ou de plan à afficher dans la table des matières.",
      "Show page numbers": "Afficher les numéros de page",
      "Show page numbers in table of contents":
        "Afficher les numéros de page dans la table des matières.",
      "Right align page numbers": "Aligner à droite les numéros de page",
      "Right align page numbers in table of contents":
        "Alignez à droite les numéros de page dans la table des matières.",
      "Use hyperlinks": "Utilisez des hyperliens",
      "Use hyperlinks instead of page numbers":
        "Utilisez des hyperliens au lieu des numéros de page.",
      Font: "Police de caractère",
      "Font Size": "Taille de police",
      "Font color": "Couleur de la police",
      "Text highlight color": "Couleur de surbrillance du texte",
      "Clear all formatting": "Effacer toute mise en forme",
      "Bold Tooltip": "Gras (Ctrl + B)",
      "Italic Tooltip": "Italique (Ctrl + I)",
      "Underline Tooltip": "Souligné (Ctrl + U)",
      Strikethrough: "Barré",
      "Superscript Tooltip": "Exposant (Ctrl + Shift ++)",
      "Subscript Tooltip": "Indice (Ctrl + =)",
      "Align left Tooltip": "Aligner à gauche (Ctrl + L)",
      "Center Tooltip": "Centre (Ctrl + E)",
      "Align right Tooltip": "Aligner à droite (Ctrl + R)",
      "Justify Tooltip": "Justifier (Ctrl + J)",
      "Decrease indent": "Diminuer le retrait",
      "Increase indent": "Augmenter le retrait",
      "Line spacing": "Interligne",
      Bullets: "Balles",
      Numbering: "Numérotage",
      Styles: "modes",
      "Manage Styles": "Gérer les styles",
      Page: "Page",
      of: "de",
      "Fit one page": "Ajuster une page",
      "Spell Check": "Vérification orthographique",
      Spelling: "Espoir, espoir",
      "Underline errors": "Souligner les erreurs",
      "Fit page width": "Ajuster la largeur de la page",
      Update: "Mise à jour",
      Cancel: "Annuler",
      Insert: "Insérer",
      "No Border": "Pas de frontière",
      "Create a new document": "Créez un nouveau document.",
      "Open a document": "Ouvrez un document.",
      "Undo Tooltip": "Annule la dernière opération (Ctrl + Z).",
      "Redo Tooltip": "Refait la dernière opération (Ctrl + Y).",
      "Insert inline picture from a file":
        "Insérez une image en ligne à partir d'un fichier.",
      "Insert a table into the document": "Insérer un tableau dans le document",
      "Create Hyperlink":
        "Créez un lien dans votre document pour un accès rapide aux pages Web et aux fichiers (Ctrl + K).",
      "Insert a bookmark in a specific place in this document":
        "Insérez un signet à un endroit spécifique de ce document.",
      "Provide an overview of your document by adding a table of contents":
        "Donnez un aperçu de votre document en ajoutant une table des matières.",
      "Add or edit the header": "Ajoutez ou modifiez l'en-tête.",
      "Add or edit the footer": "Ajoutez ou modifiez le pied de page.",
      "Open the page setup dialog":
        "Ouvrez la boîte de dialogue de mise en page.",
      "Add page numbers": "Ajoutez des numéros de page.",
      "Find Text": "Recherchez du texte dans le document (Ctrl + F).",
      "Toggle between the internal clipboard and system clipboard":
        "Basculez entre le presse-papiers interne et le presse-papiers système. </br> L'accès au presse-papiers système via un script est refusé en raison de la politique de sécurité des navigateurs. Au lieu de cela, </br> 1. Vous pouvez activer le presse-papiers interne pour couper, copier et coller dans le composant. </br> 2. Vous pouvez utiliser les raccourcis clavier (Ctrl + X, Ctrl + C et Ctrl + V) pour couper , copiez et collez avec le presse-papiers du système.",
      "Current Page Number":
        "Numéro de page actuel dans le document. Cliquez ou appuyez sur pour parcourir une page spécifique.",
      "Read only": "Lecture seulement",
      Protections: "Protections",
      "Error in establishing connection with web server":
        "Erreur lors de l'établissement de la connexion avec le serveur Web",
      Single: "Célibataire",
      Double: "Double",
      "New comment": "Nouveau commentaire",
      Comments: "commentaires",
      "Print layout": "Disposition d'impression",
      "Web layout": "mise en page Web",
      "Text Form": "Formulaire texte",
      "Check Box": "Case à cocher",
      DropDown: "Menu déroulant",
      "Update Fields": "Mettre à jour les champs",
      "Update cross reference fields":
        "Mettre à jour les champs de référence croisée",
      "Hide properties pane": "Masquer le volet des propriétés",
      "Show properties pane": "Afficher le volet des propriétés",
      "Form Fields": "Champs de formulaire",
      "Track Changes":
        "Gardez une trace des modifications apportées au document",
      TrackChanges: "Suivi des modifications",
      AllCaps: "Toutes en majuscules",
      "Change case Tooltip": "Changer de cas",
      "Insert Footnote": "Insérer une note de bas de page",
      "Insert Endnote": "Insérer une note de fin",
      "Footnote Tooltip": "Insérer une note de bas de page (Alt + Ctrl + F).",
      "Endnote Tooltip": "Insérer une note de fin (Alt + Ctrl + D).",
      UPPERCASE: "MAJUSCULE",
      "No color": "Sans couleur",
      "Top margin": "Marge supérieure",
      "Bottom margin": "Marge inférieure",
      "Left margin": "Marge de gauche",
      "Right margin": "Marge droite",
      Normal: "Normale",
      Heading: "Titre",
      "Heading 1": "Titre 1",
      "Heading 2": "Titre 2",
      "Heading 3": "Titre 3",
      "Heading 4": "Titre 4",
      "Heading 5": "Titre 5",
      "Heading 6": "Titre 6",
      ZoomLevelTooltip:
        "Le niveau de zoom. Cliquez ou appuyez sur pour ouvrir les options de zoom.",
      None: "Aucun",
      Borders: "Les frontières",
      "ShowHiddenMarks Tooltip":
        "Afficher les caractères cachés comme les espaces, les tabulations, les marques de paragraphe et les sauts.(Ctrl + *)",
      Columns: "Colonnes",
      "Column Break": "Saut de colonne",
      "Link to Previous": "lien précédent",
      "Link to PreviousTooltip":
        "Liez cette section à l'en-tête ou au pied de page de la section précédente",
      "Alternate Text": "Texte alternatif",
      "The address of this site is not valid. Check the address and try again.":
        "L'adresse de ce site n'est pas valide. ",
      OK: "D'ACCORD",
      Information: "Information",
      "Page Breaks": "à la fin des pages",
      "Section Breaks": "La division s'effondre",
      Column: "partager",
      "Next Page": "Page suivante",
      Continuous: "Continu",
    },
    carousel: {
      nextSlide: "Diapositive suivante",
      of: "de",
      pauseSlideTransition: "Interrompre la transition de diapositive",
      playSlideTransition: "Lire la transition de diapositive",
      previousSlide: "Diapositive précédente",
      slide: "Glisser",
      slideShow: "Diaporama",
    },
    message: {
      close: "Fermer",
    },
    "image-editor": {
      0: "0%",
      1: "1",
      2: "2",
      3: "3",
      4: "4",
      5: "5",
      20: "20%",
      40: "40%",
      60: "60%",
      80: "80%",
      100: "100%",
      Crop: "Recadrer",
      CropAndTransform: "Recadrer et transformer",
      ZoomIn: "Agrandir",
      ZoomOut: "Dézoomer",
      Undo: "annuler",
      Redo: "Refaire",
      Transform: "Transformer",
      Annotation: "Annotation",
      Finetune: "Affiner",
      Brightness: "Luminosité",
      Contrast: "Contraste",
      Hue: "Teinte",
      Saturation: "Saturation",
      Opacity: "Opacité",
      Blur: "Se brouiller",
      Sharpen: "Aiguiser",
      Exposure: "Exposition",
      Filter: "Filtre",
      Default: "Défaut",
      Chrome: "Chrome",
      Cold: "Froid",
      Warm: "Chaud",
      Grayscale: "Niveaux de gris",
      BlackAndWhite: "Noir et blanc",
      Sepia: "Sépia",
      Invert: "Inverser",
      Text: "Ajouter du texte",
      Pen: "Stylo",
      Reset: "Réinitialiser",
      Save: "Sauvegarder",
      Select: "Sélectionner",
      RotateLeft: "Tourne à gauche",
      RotateRight: "Tourner à droite",
      HorizontalFlip: "Retournement horizontal",
      VerticalFlip: "Retournement vertical",
      OK: "D'ACCORD",
      Cancel: "Annuler",
      DlgOK: "D'ACCORD",
      FillColor: "La couleur de remplissage",
      StrokeColor: "Couleur du trait",
      StrokeWidth: "Largeur du trait",
      FontFamily: "Famille de polices",
      FontStyle: "Le style de police",
      FontSize: "Taille de police",
      FontColor: "Couleur de la police",
      Pan: "Poêle",
      Move: "Se déplacer",
      Load: "Charger",
      Custom: "Coutume",
      Square: "Carré",
      Circle: "Cercle",
      Ellipse: "Ellipse",
      Rectangle: "Rectangle",
      Line: "Ligne",
      Arrow: "Flèche",
      Path: "Chemin",
      Bold: "Audacieux",
      Italic: "Italique",
      BoldItalic: "Gras italique",
      XSmall: "X-petit",
      Small: "Petit",
      Medium: "Moyen",
      Large: "Grand",
      XLarge: "X-Large",
      ABC: "abc",
      Browse: "Parcourir",
      Duplicate: "Dupliquer",
      Remove: "Retirer",
      EditText: "Éditer le texte",
      Start: "Commencer",
      End: "Fin",
      Bar: "Bar",
      ArrowSolid: "Flèche solide",
      CircleSolid: "Cercle solide",
      SquareSolid: "Carré Solide",
      None: "Aucun",
      CropSelection: "Sélection des cultures",
      Image: "Ajouter une image",
      Transparency: "Transparence",
      Height: "Hauteur",
      Width: "Largeur",
      AspectRatio: "Conserver les proportions",
      W: "W",
      H: "H",
      DragText: "Faites glisser et déposez votre image ici ou",
      DropText: "Déposez votre image ici ou",
      BrowseText: "Parcourez ici...",
      SupportText: "Les soutiens:",
      Frame: "Cadre",
      Mat: "Tapis",
      Bevel: "Biseau",
      Inset: "Encart",
      Hook: "Crochet",
      Color: "Couleur",
      Size: "Taille",
      Offset: "Compenser",
      Radius: "Rayon",
      Amount: "Montant",
      Resize: "Redimensionner",
      Border: "Frontière",
      Solid: "Solide",
      Dashed: "En pointillés",
      Dotted: "Pointé",
      GradientColor: "Dégradé de couleur",
      ConfirmDialogHeader: "Confirmer l'enregistrement des modifications",
      ConfirmDialogContent:
        "Voulez-vous enregistrer les modifications que vous avez apportées à l'image ?",
      AlertDialogHeader: "Fichier non supporté",
      AlertDialogContent: "Le fichier supprimé n'est pas pris en charge.",
      MinMaxSize: "avec une taille de fichier comprise entre",
      MinMaxSizeAlert: "Taille du fichier entre",
      MinSize: "avec une taille de fichier minimale de",
      MinSizeAlert: "Une taille de fichier minimale de",
      MaxSize: "avec une taille de fichier maximale de",
      MaxSizeAlert: "Une taille de fichier maximale de",
      To: "à",
      Bytes: "octets",
      Yes: "Oui",
      No: "Non",
      ImageErrorDialogHeader: "Erreur lors de la sélection de l'image",
      ImageErrorDialogContent: "Sélectionnez simplement l’image à ouvrir.",
      Straighten: "Redresser",
      NoOutline: "Pas de contour",
      Clone: "Cloner",
      Delete: "Supprimer",
      SaveAs: "Enregistrer sous",
      ImageName: "Nom d'image",
      Format: "Format",
      Quality: "Qualité",
      Download: "Télécharger",
      Close: "Fermer",
      ImageSize: "Taille de l'image",
      QualityInfo:
        "L'option de qualité d'image est uniquement disponible pour le format JPEG",
      Good: "Bien",
      Great: "Super",
      Highest: "Le plus élevé",
      BringForward: "Avancer",
      SendBackward: "Envoyer vers l'arrière",
      SendToBack: "Envoyer au fond",
      BringToFront: "Mettre au premier plan",
      ZOrder: "Ordre z",
      Redact: "Rédiger",
      Pixelate: "Pixélate",
      BorderRadius: "Rayon de frontière",
      TextOutlineColor: "Couleur de contour",
      TextOutlineWidth: "Largeur de contour",
      And: "et",
    },
    mention: {
      noRecordsTemplate: "Aucun enregistrement trouvé",
    },
    inplaceeditor: {
      save: "Sauvegarder",
      cancel: "Annuler",
      loadingText: "Chargement...",
      editIcon: "Cliquez pour modifier",
      editAreaClick: "Cliquez pour modifier",
      editAreaDoubleClick: "Double-cliquez pour modifier",
    },
    PdfViewer: {
      PdfViewer: "Visionneuse PDF",
      Cancel: "Annuler",
      "Download file": "Télécharger un fichier",
      Download: "Télécharger",
      "Enter Password": "Ce document est protégé par mot de passe. ",
      "File Corrupted": "Fichier corrompu",
      "File Corrupted Content":
        "Le fichier est corrompu et ne peut pas être ouvert.",
      "Fit Page": "Ajuster la page",
      "Fit Width": "Ajuster la largeur",
      Automatic: "Automatique",
      "Go To First Page": "Afficher la première page",
      "Invalid Password": "Mot de passe incorrect. ",
      "Next Page": "Afficher la page suivante",
      OK: "D'ACCORD",
      Open: "Fichier ouvert",
      "Page Number": "Numéro de page actuel",
      "Previous Page": "Afficher la page précédente",
      "Go To Last Page": "Afficher la dernière page",
      Zoom: "Zoom",
      "Zoom In": "Agrandir",
      "Zoom Out": "Dézoomer",
      "Page Thumbnails": "Miniatures de pages",
      Bookmarks: "Signets",
      Print: "Imprimer le fichier",
      "Organize Pages": "Organiser les pages",
      "Insert Right": "Insérer à droite",
      "Insert Left": "Insérer à gauche",
      Total: "Total",
      Pages: "Pages",
      "Rotate Right": "Tourner à droite",
      "Rotate Left": "Tourne à gauche",
      "Delete Page": "Supprimer la page",
      "Delete Pages": "Supprimer des pages",
      "Copy Page": "Page de copie",
      "Copy Pages": "Copier les pages",
      "Import Document": "Document d'importation",
      Save: "Sauvegarder",
      "Save As": "Enregistrer sous",
      "Select All": "Tout sélectionner",
      "Password Protected": "Mot de passe requis",
      Copy: "Copie",
      "Text Selection": "Outil de sélection de texte",
      Panning: "Mode panoramique",
      "Text Search": "Rechercher du texte",
      "Find in document": "Rechercher dans le document",
      "Match case": "Cas de correspondance",
      "Match any word": "Faites correspondre tout mot",
      Apply: "Appliquer",
      GoToPage: "Aller à la page",
      "No Matches":
        "PDF Viewer a terminé la recherche dans le document. Aucune correspondance n'a été trouvée.",
      "No More Matches":
        "PDF Viewer a terminé la recherche dans le document. Aucune autre correspondance n’a été trouvée.",
      "Exact Matches": "Matchs exacts",
      "Total Matches": "Total des matchs",
      Undo: "annuler",
      Redo: "Refaire",
      Annotation: "Ajouter ou modifier des annotations",
      FormDesigner: "Ajouter et modifier les champs de formulaire",
      Highlight: "Texte surligné",
      Underline: "Souligner le texte",
      Strikethrough: "Texte barré",
      Delete: "Supprimer l'annotation",
      Opacity: "Opacité",
      "Color edit": "Changer de couleur",
      "Opacity edit": "Changer l'opacité",
      "Highlight context": "Souligner",
      "Underline context": "Souligner",
      "Strikethrough context": "Traverser",
      "Server error": "Le service Web n'écoute pas. ",
      "Client error":
        "Une erreur côté client est trouvée. Veuillez vérifier les en-têtes personnalisés fournis dans la propriété AjaxRequestSettings et les méthodes d'action Web dans la propriété ServerActionSettings.",
      "Open text": "Ouvrir",
      "First text": "Première page",
      "Previous text": "Page précédente",
      "Next text": "Page suivante",
      "Last text": "Dernière page",
      "Zoom in text": "Agrandir",
      "Zoom out text": "Dézoomer",
      "Selection text": "Sélection",
      "Pan text": "Poêle",
      "Print text": "Imprimer",
      "Search text": "Recherche",
      "Annotation Edit text": "Modifier l'annotation",
      "FormDesigner Edit text": "Ajouter et modifier les champs de formulaire",
      "Line Thickness": "Épaisseur de ligne",
      "Line Properties": "Propriétés de ligne",
      "Start Arrow": "Flèche de départ",
      "End Arrow": "Flèche de fin",
      "Line Style": "Style de ligne",
      "Fill Color": "La couleur de remplissage",
      "Line Color": "Couleur de la ligne",
      None: "Aucun",
      "Open Arrow": "Ouvrir",
      "Closed Arrow": "Fermé",
      "Round Arrow": "Rond",
      "Square Arrow": "Carré",
      "Diamond Arrow": "diamant",
      Butt: "Bout",
      Cut: "Couper",
      Paste: "Coller",
      "Delete Context": "Supprimer",
      Properties: "Propriétés",
      "Add Stamp": "Ajouter un tampon",
      "Add Shapes": "Ajouter des formes",
      "Stroke edit": "Changer la couleur du trait",
      "Change thickness": "Modifier l'épaisseur de la bordure",
      "Add line": "Ajouter une ligne",
      "Add arrow": "Ajouter une flèche",
      "Add rectangle": "Ajouter un rectangle",
      "Add circle": "Ajouter un cercle",
      "Add polygon": "Ajouter un polygone",
      "Add Comments": "Ajoutez des commentaires",
      Comments: "commentaires",
      SubmitForm: "Soumettre le formulaire",
      "No Comments Yet": "Aucun commentaire pour l'instant",
      Accepted: "Accepté",
      Completed: "Complété",
      Cancelled: "Annulé",
      Rejected: "Rejeté",
      "Leader Length": "Longueur du leader",
      "Scale Ratio": "Rapport d'échelle",
      Calibrate: "Étalonner",
      "Calibrate Distance": "Calibrer la distance",
      "Calibrate Perimeter": "Calibrer le périmètre",
      "Calibrate Area": "Calibrer la zone",
      "Calibrate Radius": "Calibrer le rayon",
      "Calibrate Volume": "Calibrer le volume",
      Depth: "Profondeur",
      Closed: "Fermé",
      Round: "Rond",
      Square: "Carré",
      Diamond: "diamant",
      Edit: "Modifier",
      Comment: "Commentaire",
      "Comment Panel": "Groupe de commentaires",
      "Set Status": "Définir le statut",
      Post: "Poste",
      Page: "Page",
      "Add a comment": "Ajouter un commentaire",
      "Add a reply": "Ajouter une réponse",
      "Import Annotations": "Importer des annotations à partir du fichier JSON",
      "Export Annotations": "Exporter l'annotation vers le fichier JSON",
      "Export XFDF": "Exporter l'annotation vers le fichier XFDF",
      "Import XFDF": "Importer des annotations à partir du fichier XFDF",
      Add: "Ajouter",
      Clear: "Clair",
      Bold: "Audacieux",
      Italic: "Italique",
      Strikethroughs: "Barré",
      Underlines: "Souligner",
      Superscript: "Exposant",
      Subscript: "Indice",
      "Align left": "Alignez à gauche",
      "Align right": "Aligner à droite",
      Center: "Centre",
      Justify: "Justifier",
      "Font color": "Couleur de la police",
      "Text Align": "Aligner le texte",
      "Text Properties": "Le style de police",
      SignatureFieldDialogHeaderText: "Ajouter une signature",
      HandwrittenSignatureDialogHeaderText: "Ajouter une signature",
      InitialFieldDialogHeaderText: "Ajouter initial",
      HandwrittenInitialDialogHeaderText: "Ajouter initial",
      "Draw Ink": "Dessiner de l'encre",
      Create: "Créer",
      "Font family": "Famille de polices",
      "Font size": "Taille de police",
      "Free Text": "Texte libre",
      "Import Failed":
        "Type de fichier JSON non valide ou nom de fichier; Veuillez sélectionner un fichier JSON valide",
      "Import PDF Failed":
        "Type de fichier PDF non valide ou fichier PDF introuvable. Veuillez sélectionner un fichier PDF valide",
      "File not found":
        "Le fichier JSON importé n'est pas trouvé dans l'emplacement souhaité",
      "Export Failed":
        "L'action des annotations d'exportation a échoué; Veuillez vous assurer que les annotations sont ajoutées correctement",
      of: "de",
      Dynamic: "Dynamique",
      "Standard Business": "Entreprise standard",
      "Sign Here": "Signez ici",
      "Custom Stamp": "Timbre personnalisé",
      "Enter Signature as Name": "Entrez votre nom",
      "Draw-hand Signature": "DESSINER",
      "Type Signature": "TAPER",
      "Upload Signature": "TÉLÉCHARGER",
      "Browse Signature Image": "PARCOURIR",
      "Save Signature": "Enregistrer la signature",
      "Save Initial": "Économiser initial",
      Textbox: "Zone de texte",
      Password: "Mot de passe",
      "Check Box": "Case à cocher",
      "Radio Button": "Bouton radio",
      Dropdown: "Dérouler",
      "List Box": "Liste de listes",
      Signature: "Signature",
      "Delete FormField": "Supprimer le champ de formulaire",
      "Textbox Properties": "Propriétés de la zone de texte",
      Name: "Nom",
      Tooltip: "Info-bulle",
      Value: "Valeur",
      "Form Field Visibility": "Forme de visibilité sur le terrain",
      "Read Only": "Lecture seulement",
      Required: "Requis",
      Checked: "Vérifié",
      "Show Printing": "Afficher l'impression",
      Formatting: "Format",
      Fill: "Remplir",
      Border: "Frontière",
      "Border Color": "Couleur de la bordure",
      Thickness: "Épaisseur",
      "Max Length": "Longueur maximale",
      "List Item": "Nom de l'article",
      "Export Value": "Valeur de l'élément",
      "Dropdown Item List": "Liste des articles déroulants",
      "List Box Item List": "Liste des éléments de la boîte",
      General: "GÉNÉRAL",
      Appearance: "APPARENCE",
      Options: "OPTIONS",
      "Delete Item": "Supprimer",
      Up: "En haut",
      Down: "Vers le bas",
      Multiline: "Multiligne",
      Revised: "modifié",
      Reviewed: "Révisé",
      Received: "Reçu",
      Confidential: "Confidentiel",
      Approved: "Approuvé",
      "Not Approved": "Non approuvé",
      Witness: "Témoin",
      "Initial Here": "Vos initiales ici",
      Draft: "Brouillon",
      Final: "Final",
      "For Public Release": "Pour libération publique",
      "Not For Public Release": "Pas pour la libération publique",
      "For Comment": "Pour commenter",
      Void: "Vide",
      "Preliminary Results": "Résultats préliminaires",
      "Information Only": "Information seulement",
      in: "dans",
      m: "m",
      ft_in: "ft_in",
      ft: "pi",
      p: "p",
      cm: "cm",
      mm: "mm",
      pt: "pt",
      cu: "cu",
      sq: "carré",
      Initial: "Initial",
      "No Search Matches": "Aucun résultat",
      "No More Search Matches": "Aucune autre correspondance trouvée",
      "No matches": "La visionneuse a terminé la recherche dans le document. ",
      "No Text Found": "Aucun texte trouvé",
    },
    stepper: {
      optional: "Facultatif",
    },
  },
};
